import React from "react";
import { useState, useEffect, useCallback, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import "react-data-table-component-extensions/dist/index.css";
import DataService from ".././../services/tutorial.service";
import { Link, useHistory } from "react-router-dom";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as AiIcons from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import { Image, Shimmer } from "react-shimmer";
import LoadingOverlay from "react-loading-overlay-ts";
import { playerlistData, teamlistData, setisfirsttime, playerfilter } from "../../actions/index";
import { encode } from "base-64";
import { auctiondefaultLogo, bgtop1, teamdefaultLogo, toplprofile } from "../../constants/Images";
import { tele } from "../../constants/Images";
import { mask } from "../../constants/Images";
import { plbg } from "../../constants/Images";
import { ribbin } from "../../constants/Images";
import { soldstamp } from "../../constants/Images";
import { pdfauctiontitlebg } from "../../constants/Images";
import { ribbin3, ribbin2, tagbadge } from "../../constants/Images";
// import { ribbin3 } from "../../constants/Images";
import { topborderirng, pdflayout1, pdflayout2 } from "../../constants/Images";
import { ribinfo } from "../../constants/Images";
import { BASE_PATH } from "../../constants/Global";
import { TiUserDelete } from "react-icons/ti";
import { useReactToPrint } from 'react-to-print';
// import { PDFDownloadLink, Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';




// import * as fontkit from 'fontkit'; // Import all exports
// import html2pdf from 'html2pdf.js/html2pdf';

import { confirmAlert } from "react-confirm-alert";
import { playerdefaultLogo } from "../../constants/Images";
import { getAge } from "../../Helpers/Helpers";
import NotFound from "../include/NotFound";
import BounceLoader from "react-spinners/ClipLoader";
import jsPDF from 'jspdf';
import { pdfbg, top2bg, rankbadge, pdfbgcustom1 } from "../../constants/Images";
import { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faC, faXmark } from '@fortawesome/free-solid-svg-icons'
import { faFlag } from '@fortawesome/free-solid-svg-icons'
import { faCrown } from '@fortawesome/free-solid-svg-icons'
// import { useHistory } from 'react-router-dom';
import * as XLSX from 'xlsx';
import axios from 'axios';
import html2canvas from 'html2canvas';
import { getDatabase, ref, remove, onValue, set, push, update } from "firebase/database";
import { FirebaseContext } from '../../FirebaseContext';
import { actlistData } from "../../actions/index";
// import { color } from "html2canvas/dist/types/css/types/color";

function Players(match) {
  const reportTemplateRef = useRef(null);

  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [currentauc, setcurrentauc] = useState([]);
  const [pldata, setplData] = useState([]);
  const [dataTeam, setTeamData] = useState([]);
  const [isActive, setActive] = useState(false);
  const [isspnshow, setisspnshow] = useState(false);
  const getpageData = useSelector((state) => state.setplayerlistData);
  const loginuser = useSelector((state) => state.setUserlog);
  const getteampageData = useSelector((state) => state.setteamlistData);
  const getcatpageData = useSelector((state) => state.setcatlistData);
  const getfilters = useSelector((state) => state.setplfilters);

  const [admin_id, setadminid] = useState(localStorage.getItem('admin_id'));
  const [admin_name, setadmin_name] = useState(localStorage.getItem('admin_name'));

  const aucdatalist = useSelector((state) => state.setactlistData);

  const aid = localStorage.getItem("auction_id");
  const acname = localStorage.getItem("auction_name");
  const [hoveredCard, setHoveredCard] = useState(null);
  const [selectedpllist, setselectedpllist] = useState([]);

  const [cid, setCid] = useState(loginuser["cid"]);
  const [pdfclk, setpdfclk] = useState(false);
  const [isexcelclk, setisexcelclk] = useState(false);
  const [orderby, setorderby] = useState("");
  const [orderby2, setorderby2] = useState("");
  const [exceltype, setexceltype] = useState("");
  const [colno, setcolno] = useState("");
  const [numofpl, setnumofpl] = useState("");
  const [plcat, setplcat] = useState("");
  const [pdfDataUri, setPdfDataUri] = useState(null);
  const [sts, setsts] = useState("");
  const [catdata, setcatData] = useState("");
  const [filorder, setfilorder] = useState("");
  const [issetdata, setissetdata] = useState(false);
  const [isbulkdelenable, setisbulkdelenable] = useState(false);
  const [isplnoshow, setisplnoshow] = useState(true);
  const [ismobnoshow, setismobnoshow] = useState(false);
  const [istshirtshow, setistshirtshow] = useState(false);
  const [ispointsshow, setispointsshow] = useState(true);
  const [isdetailshow, setisdetailshow] = useState(false);
  const [isbasePriceShow, setisbasePriceShow] = useState(false);
  const [iscatshow, setiscatshow] = useState(true);
  const [isownershow, setisownershow] = useState(false);
  const [isvalshow, setisvalshow] = useState(true);
  const [isspec1, setisspec1] = useState(true);
  const [isspec2, setisspec2] = useState(true);
  const [isspec3, setisspec3] = useState(true);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [baseimage, setbaseimage] = useState("");
  const [renderCount, setRenderCount] = useState(0);
  const [base64Images, setBase64Images] = useState([]);
  const [roundbase64Images, setroundBase64Images] = useState([]);
  const [aucteambase64, setaucteambase64] = useState([]);
  const [aucdata, setaucdata] = useState([]);
  const [auclogo, setauclogo] = useState();
  const [aucdate, setaucdate] = useState();
  const [auclogopath, setauclogopath] = useState();
  const [aucminbid, setaucminbid] = useState();
  const [teampath, setteampath] = useState("");
  const [isexcelmore, setisexcelmore] = useState("");
  const [isexcelsp1, setisexcelsp1] = useState(true);
  const [isexcelsp2, setisexcelsp2] = useState(true);
  const [isexcelsp3, setisexcelsp3] = useState(false);
  const [isexceltshirt, setisexceltshirt] = useState(true);
  const [isexceltrouser, setisexceltrouser] = useState(true);
  const [isexcelcat, setisexcelcat] = useState(true);
  const [isexcelplno, setisexcelplno] = useState(true);
  const [isexcelage, setisexcelage] = useState(true);
  const [isexcelmob, setisexcelmob] = useState(true);
  const [isexceldob, setisexceldob] = useState(true);
  const [isexcelpoints, setisexcelpoints] = useState(true);
  const [isexcelteam, setisexcelteam] = useState(true);
  const [isexcelfname, setisexcelfname] = useState(true);
  const [isexceljname, setisexceljname] = useState(true);
  const [isexceljno, setisexceljno] = useState(true);
  const [isexceldetail, setisisexceldetail] = useState(true);
  const [isexcelimage, setisexcelimage] = useState(true);
  const [isexcelbasebid, setisexcelbasebid] = useState(false);
  const [topnum, settopnum] = useState(5)
  const [toptype, settoptype] = useState('0')
  const [sponsorlogo, setsponsorlogo] = useState("")
  const [ignoretype, setignoretype] = useState("")
  const [ignorecat, setignorecat] = useState("")
  const [ignoretag, setignoretag] = useState("")
  const [ignoreplnos, setignoreplnos] = useState("")
  const [pdflayouttype, setpdflayouttype] = useState("")
  const [toppltype, settoppltype] = useState("")

  const [isownertagselect, setisownertagselect] = useState(true)
  const [iscoownertagselect, setiscoownertagselect] = useState(true)
  const [iscaptaintagselect, setiscaptaintagselect] = useState(true)
  const [isicontagselect, setisicontagselect] = useState(true)
  const [isretaintagselect, setisretaintagselect] = useState(true)
  const [fontcolor, setcolor] = useState(localStorage.getItem('pdffont'))

  // const [isexcelsp1, setisexcelsp1] = useState("");
  // const [isexcelmore, setisexcelmore] = useState("");
  // const [isexcelmore, setisexcelmore] = useState("");
  // const [isexcelmore, setisexcelmore] = useState("");
  // const [excelfields, setexcelfields] = useState({""});

  const updtoken = useSelector((state) => state.updtoken);
  const { upddata } = useContext(FirebaseContext);
  const isfirsttime = useSelector((state) => state.isfirsttime);
  const getaucpageData = useSelector((state) => state.setactlistData);
  const aucmoredetail = useSelector((state) => state.actmoredata);

  // const history = useHistory({ forceRefresh: true });


  const [filter, setFilter] = useState(getfilters != 0 ? getfilters : {
    searchText: '',
    selectedStatus: '',
    selectedCategory: '1',
  });
  const imageRefs = useRef([]);
  const aucteamrefs = useRef([]);
  const pldefault = useRef([]);
  // const canvasRefs = useRef([]);

  // const imageRef = useRef(null);
  const pdfContainerRefs = useRef([]);
  // const yourImageRef = useRef(null);
  const history = useHistory();



  const fetchcatData = async () => {
    // setActive(true);

    var hdr = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        "Authorization": JSON.stringify([{ 'cid': cid, 'token': loginuser["token"] }])
      }
    }

    await DataService.listCategory({ 'aid': aid }, hdr)
      .then(res => {

        let response = res.data;
        if (response.success == true) {
          // //  console.log(responsedata)
          let responsedata = response.data;
          // //  console.log(" cat list kya h");
          // //  console.log(responsedata.list.sort((a, b) => a.catord - b.catord));

          setcatData(responsedata.list.sort((a, b) => a.catord - b.catord));
        }
        // setActive(false);

      }).catch(() => {
        //  console.log('Not valid')
        // setActive(false);
      })
  };
  // const handleGeneratePdf = () => {
  //   const doc = new jsPDF({
  //     format: 'a4',
  //     unit: 'px',
  //   });

  //   // Adding the fonts.
  //   doc.setFont('Inter-Regular', 'normal');

  //   doc.html(reportTemplateRef.current, {
  //     async callback(doc) {
  //       await doc.save('document');
  //     },
  //   });
  // };
  const handleGeneratePdf = () => {
    const input = reportTemplateRef.current;
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      // const imgWidth = canvas.width;
      // const imgHeight = canvas.height;
      // const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      // const imgX = (pdfWidth - imgWidth * ratio) / 2;
      // const imgY = 30;
      pdf.addImage(imgData, 'PNG', 0, 0, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight());
      pdf.save('player_report.pdf');
    });
  };
  const fetchaucData = async () => {
    setActive(true);
    // //  console.log("fetch cid:" + cid);
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid, token: loginuser["token"] }]),
      },
    };

    await DataService.listAuction({ myauction: 1 }, hdr)
      .then((res) => {
        let response = res.data;

        if (response.success == true) {
          let responsedata = response.data;

          setaucdata(responsedata)

          setcurrentauc(responsedata.list.filter((ele) => ele.aid == aid)[0])
          setauclogo(responsedata.list.filter((ele) => ele.aid == aid)[0].logo)
          setaucdate(responsedata.list.filter((ele) => ele.aid == aid)[0].dt)
          setaucminbid(responsedata.list.filter((ele) => ele.aid == aid)[0].minbid)
          setauclogopath(responsedata.path)
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        setActive(false);
      });
  };



  const fetchTeamData = async () => {
    var hdr = {
      params: {
        frm: 1,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.listTeam({}, hdr)
      .then((res) => {
        let response = res.data;
        if (response.success == true) {
          let responsedata = response.data;
          // console.log('responsedata.list')
          // console.log(responsedata.list)

          setTeamData(responsedata.list);
          setteampath(responsedata.path);
          dispatch(teamlistData({ responsedata }));
        }
      })
      .catch(() => {
        //  console.log("Not valid");
      });
  };


  const fetchData = async () => {

    //  console.log("api called again....")
    // //  console.log(aid)
    setActive(true);

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded", //v
        Authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.listPlayer({ self: 1 }, hdr)
      .then((res) => {
        let response = res.data;
        //  console.log('players data')
        //  console.log(response)

        if (response.success == true) {
          let responsedata = response.data;
          setData(responsedata);
          //  console.log('data coming.....')
          //  console.log(responsedata)
          setplData(responsedata);
          dispatch(playerlistData({ responsedata }));
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        setActive(false);
      });


  };

  const del = useCallback(
    async (vl, status) => {
      if (status == 1) {
        setActive(true);

        var hdr = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: JSON.stringify([
              { cid: cid, aid: aid, token: loginuser["token"] },
            ]),
          },
        };

        await DataService.deletePlayer({ pid: encode(vl) }, hdr)
          .then((res) => {
            let response = res.data;
            if (response.success == true) {
              const db = getDatabase();

              set(ref(db, 'auction/info/' + aid), { "type": "4", "upd": "3", 'id': vl, "detail": "", "tkn": updtoken });
              toast.success(response.msg, {
                theme: "dark",
                position: "bottom-center",
              });
              const updateitem = data.list.filter((ele, ind) => {
                return ele.pid != vl;
              });
              data.list = updateitem;
              setData(data);
            } else {
              toast.error(response.msg, {
                theme: "colored",
                position: "bottom-center",
              });
            }
            setActive(false);
          })
          .catch(() => {
            //  console.log("Not valid");
            toast.error("Not valid Server Error", {
              theme: "colored",
              position: "bottom-center",
            });
            setActive(false);
          });
      }
    },
    [data]
  );

  const deldata = (id) => {
    confirmAlert({
      message: "Are you sure delete this record !",
      buttons: [
        {
          label: "Yes",
          onClick: () => del(id, 1),
        },
        {
          label: "No",
          onClick: () => del(id, 0),
        },
      ],
    });
  };

  function gotoimport() {
    history.push(BASE_PATH + 'import-players')
  }
  function pdfdownload() {
    if (data != "") {
      // orderby1-------------------------------------------
      if (orderby == 2) {
        var pdfdata = [...data.list].sort((a, b) =>
          a.pname.toLowerCase() < b.pname.toLowerCase() ? -1 : 1,
        );
      }
      else if (orderby == 1) {
        var pdfdata = data.list
      }
      else if (orderby == 5 || orderby2 == 3) {
        var teamwisefull = []


        dataTeam.forEach((tm) => {
          var teamwise = []
          teamwise = data.list.filter((dt) => dt.tmid == tm.tid)


          if (orderby == 5) {
            if (teamwise.length > 0) {

              teamwise.sort((a, b) => a.soldseq - b.soldseq)
            }
            teamwise.forEach((ele) => {
              teamwisefull.push(ele)
            })

          }
          else if (orderby == 7) {
            if (teamwise.length > 0) {

              teamwise.sort((a, b) => b.points - a.points)
            }
            teamwise.forEach((ele) => {
              teamwisefull.push(ele)
            })

          }
          else if (orderby == 8) {
            if (teamwise.length > 0) {

              teamwise.sort((a, b) =>
                a.pname.toLowerCase() < b.pname.toLowerCase() ? -1 : 1,
              );
            }
            teamwise.forEach((ele) => {
              teamwisefull.push(ele)
            })

          }
          else if (orderby == 6 && catdata !== "") {
            if (teamwise.length > 0) {
              // var catteammain=[]
              catdata.forEach((ct) => {
                var catteam = []
                teamwise.forEach((tw) => {
                  if (ct.cid == tw.catid) {
                    catteam.push(tw)
                  }
                })
                if (catteam.length > 0) {
                  catteam.forEach((ele) => {
                    teamwisefull.push(ele)
                  })
                }
              })
              teamwise.forEach((tw) => {
                if (tw.catid == "0") {
                  teamwisefull.push(tw)
                }
              })


            }
          }
          else {
            teamwise.forEach((ele) => {
              teamwisefull.push(ele)
            })
          }


        })


        var pdfdata = teamwisefull
      }
      else {
        var pdfdata = data.list
      }
      // orderby2-------------------------------------------
      if (orderby2 == 2 || orderby == 3 || orderby == 4) {
        if (catdata !== "" && catdata !== null) {

          var catwisefull = []

          catdata.forEach((ct) => {
            var catwise = []
            catwise = data.list.filter((dt) => dt.catid == ct.cid)
            if (catwise.length > 0) {
              if (orderby == 2 || orderby == 4) {
                catwise.sort((a, b) =>
                  a.pname.toLowerCase() < b.pname.toLowerCase() ? -1 : 1,
                );
              }
              catwise.forEach((ele) => {
                catwisefull.push(ele)
              })
            }
          })
          var pdfdata = catwisefull
          // console.log('pdfdata')
          // console.log(pdfdata)
        }


      }
      // else if(orderby2==1 || orderby2==""){
      //   var pdfdata = data.list
      // }
      //


      // column number----------------------------------------------------------
      if (colno == 1) {
        var column = 2;
      }
      else if (colno == 2) {
        var column = 3;
      }
      else {
        var column = 3;
      }
      // perpage--------------------------------------------------
      if (numofpl == "" && colno == 2) {
        var perpage = 27;
      }
      else if (numofpl == "" && colno == 1) {
        var perpage = 14;
      }
      else if (numofpl !== '') {
        var perpage = numofpl;

      }
      else {
        var perpage = 27;

      }


      // status-------------------------------------------------------------------
      if (sts == "" || sts == 1) {
        var pdfdata = pdfdata;
      }
      else {
        if (sts == 2) {
          var pdfdata = pdfdata.filter((pl) => (pl.tmid == 0 || pl.tmid == "") && pl.isskiped != '1')
        }
        else if (sts == 3) {
          // //  console.log("team ke anusaar")
          var pdfdata = pdfdata.filter((pl) => pl.tmid > 0)

        }
        else if (sts == 4) {
          // //  console.log("team ke anusaar")
          var pdfdata = pdfdata.filter((pl) => pl.isskiped == '1')

        }
        else if (sts == 5) {
          // //  console.log("team ke anusaar")
          var pdfdata = pdfdata.filter((pl) => pl.tmid == 0 || pl.tmid == "")
        }
        else if (sts == 6) {
          // //  console.log("team ke anusaar")
          var pdfdata = pdfdata.filter((pl) => pl.tmid == 0 || pl.tmid == "")
        }
      }

      if (pdfdata == [] || pdfdata == null || pdfdata.length == 0) {
        alert('No Player Data !!')
        return 0
      }

      // var pdfdata = [...data.list].sort((a, b) =>
      //   a.fname < b.fname.toLowerCase() ? -1 : 1,
      // );
      // console.log('pdfdata', pdfdata);

      const doc = new jsPDF();

      // doc.text('Player List', 15, 10);

      // let yOffset = 20;
      ///-----2/3 column
      ///--first page / Per page record
      //////////////////////////////2X6///////////////////////////////////////////////////////////////

      if (column == 2 && perpage == 12) {
        var perpage = 12;

        var rightbox = 98;
        var bottombox = 40;

        var rectwide = 94;
        var reactheight = 32;

        var imgwidth = 30;
        var imgheight = 30;

        var nameagefont = 12;
        var namex = 33;
        var namey = 5;
        var agex = 53;
        var agey = 11;

        var plnox = 33;
        var plnoy = 11

        var spcffont = 10;
        var spcfx = 33;
        var spcfy = 20;
        var extra = 2;

      }
      ///////////////////////////////////////////2 x 7//////////////////////////////////////////////////////////////////

      if (column == 2 && perpage == 14) {
        var perpage = 14;

        var rightbox = 98;
        var bottombox = 33;

        var rectwide = 94;
        var reactheight = 29;

        var imgwidth = 27;
        var imgheight = 27;

        var nameagefont = 12;
        var namex = 30;
        var namey = 5;
        var agex = 50;
        var agey = 11;

        var plnox = 30;
        var plnoy = 11

        var spcffont = 10;
        var spcfx = 30;
        var spcfy = 20;
        var extra = 2;
      }
      ///////////////////////////////////////////////2 x 8/////////////////////////////////////////////////////////////

      if (column == 2 && perpage == 16) {
        var perpage = 16;

        var rightbox = 98;
        var bottombox = 29;

        var rectwide = 94;
        var reactheight = 26;

        var imgwidth = 24;
        var imgheight = 24;

        var nameagefont = 10;
        var namex = 28;
        var namey = 5;
        var agex = 48;
        var agey = 11;

        var plnox = 28;
        var plnoy = 11

        var spcffont = 9;
        var spcfx = 28;
        var spcfy = 20;

        var extra = 2;
      }
      /////////////////////////////////////// 3 x 8 //////////////////////////////////////////////////////////////
      if (column == 3 && perpage == 24) {
        var perpage = 24;

        var rightbox = 65;
        var bottombox = 29;

        var rectwide = 62;
        var reactheight = 22;

        var imgwidth = 20;
        var imgheight = 20;

        var nameagefont = 8;
        var namex = 22;
        var namey = 4;
        var agex = 42;
        var agey = 9;

        var plnox = 22;
        var plnoy = 9

        var spcffont = 7;
        var spcfx = 22;
        var spcfy = 16;
        var extra = 6;
      }
      /////////////////////////////////////////////// 3 x 9 ///////////////////////////////////////////////////////////////////
      if (column == 3 && perpage == 27) {
        var perpage = 27;

        var rightbox = 65;
        var bottombox = 26;

        var rectwide = 62;
        var reactheight = 22;

        var imgwidth = 20;
        var imgheight = 20;

        var nameagefont = 8;
        var namex = 22;
        var namey = 4;
        var agex = 42;
        var agey = 9;

        var plnox = 22;
        var plnoy = 9

        var spcffont = 7;
        var spcfx = 22;
        var spcfy = 16;

        var extra = 6;

      }
      //////////////////////////////////////////// 3 x 10 ///////////////////////////////////////////////////
      if (column == 3 && perpage == 30) {
        var perpage = 30;

        var rightbox = 65;
        var bottombox = 23;

        var rectwide = 62;
        var reactheight = 22;

        var imgwidth = 20;
        var imgheight = 20;

        var nameagefont = 8;
        var namex = 22;
        var namey = 4;
        var agex = 42;
        var agey = 9;

        var plnox = 22;
        var plnoy = 9

        var spcffont = 7;
        var spcfx = 22;
        var spcfy = 16;

        var extra = 6;

      }
      /////////////////////////////////////////////////////////////////////////////////////////////////
      if (column == 3 && perpage == 33) {
        var perpage = 33;

        var rightbox = 65;
        var bottombox = 21;

        var rectwide = 62;
        var reactheight = 20;

        var imgwidth = 18;
        var imgheight = 18;

        var nameagefont = 7;
        var namex = 21;
        var namey = 4;
        var agex = 42;
        var agey = 9;

        var plnox = 21;
        var plnoy = 9

        var spcffont = 6;
        var spcfx = 21;
        var spcfy = 14;
        var extra = 6
      }

      function linechanger(str, count) {
        var plsp = str.split(" ")
        let plsplen = 0;
        let whichsp = 0;
        let firststr = "";
        let secstr = "";
        for (let i = 0; i < plsp.length; i++) {
          plsplen += plsp[i].length;

          if (plsplen > count) {

            break;
          }
          whichsp += 1

        }
        var linearr = []
        for (let y = 0; y < whichsp; y++) {
          if (firststr !== '') {
            firststr += " "
          }
          firststr += plsp[y];
        }
        linearr.push(firststr)

        for (let z = whichsp; z < plsp.length; z++) {
          if (secstr !== '') {
            secstr += " "
          }
          secstr += plsp[z];
        }
        linearr.push(secstr)
        return linearr
      }
      var counter = 0
      var count2 = 0
      var plno = 1
      let x = 10;
      let y = 60;

      doc.addImage((aucmoredetail && aucmoredetail?.more[0]?.pdfbg) ? (aucmoredetail?.fpath + aucmoredetail?.more[0].pdfbg) : pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
      // //  console.log("jjjjjjjjjjjjjjjjjjjjjj")

      // //  console.log(aucteambase64)
      // doc.setFillColor(255, 255, 255);
      // doc.rect(10, 10, 40, 40,'F');
      // doc.rect(160, 10, 40, 40);

      // //  console.log(aucteambase64[0])
      // //  console.log(aucteambase64[1])
      if (aucteambase64[0]) {
        doc.addImage(aucteambase64[0], 'JPEG', 10, 10, 40, 40);
        if (isspnshow && aucteambase64[1]) {
          doc.addImage(aucteambase64[1], 'JPEG', 160, 10, 40, 40);

        }
        else {

          doc.addImage(aucteambase64[0], 'JPEG', 160, 10, 40, 40);
        }
        // //  console.log("jjjjjjjjjjjjjjjjjjjjjj2222222222222222")

      }
      else {
        doc.addImage(auctiondefaultLogo, 'JPEG', 10, 10, 40, 40);
        doc.addImage(auctiondefaultLogo, 'JPEG', 160, 10, 40, 40);

      }
      if (orderby2 == 3) {
        if (aucteambase64[pdfdata[0].tmid]) {

          doc.addImage(aucteambase64[pdfdata[0].tmid], 'JPEG', 10, 10, 40, 40);
        }
      }
      // doc.setDrawColor(72, 104, 153);

      //   doc.rect(9.5, 9.5, 41, 41);

      // doc.setDrawColor(72, 104, 153);
      // doc.rect(159.5, 9.5, 41, 41);

      if (fontcolor == 0) {
        doc.setTextColor(255, 255, 255);
      }
      else {
        doc.setTextColor(20, 14, 92);
      }
      doc.setFontSize(18);
      if (acname.length < 27) {

        let alen = acname.length * 4
        // doc.setTextColor(196, 147, 14);

        doc.text(acname.toUpperCase(), 105 - alen / 2, 18);
        // doc.setTextColor(255, 255, 255);

      }
      else {
        doc.setFontSize(15);

        var fstr = linechanger(acname, 27)
        let alen1 = fstr[0].length * 3.2

        doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 18);
        if (fstr[1].length <= 25) {
          doc.setFontSize(14);

          let alen2 = fstr[1].length * 2.9

          doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 24);
        } else {
          var fsstr = linechanger(fstr[1], 25);
          doc.setFontSize(14);

          let alen2 = fsstr[0].length * 2.9;
          let alen3 = fsstr[1].length * 2.9;

          doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 24);
          doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 30);
        }


      }
      doc.setFontSize(10);
      if (orderby2 == 3 || orderby2 == 2) {
        // doc.text('TEAM PLAYER LIST', 88, 45);

      }
      else {
        if (fontcolor == 0) {

          doc.setTextColor(196, 147, 14);
        }
        else {
          doc.setTextColor(22, 14, 117);

        }
        if (sts == 4 || sts == 5) {

          doc.text('UNSOLD PLAYER LIST', 85, 37);
        }
        else if (sts == 2 || sts == 6) {
          doc.text('AVAILABLE PLAYER LIST', 85, 37);

        }
        else {
          doc.text('AUCTION PLAYER LIST', 85, 37);
        }
        if (fontcolor == 0) {
          doc.setTextColor(255, 255, 255);
        }
        else {
          doc.setTextColor(20, 14, 92);
        }
      }
      doc.setFontSize(16);



      var dumcatid = pdfdata[0].catid;
      var dumtid = pdfdata[0].tmid;

      if (pdflayouttype == '1') {
        pdfdownload2(pdfdata)
        return 0
      }
      //  console.log('pdf player list')
      //  console.log(pdfdata)
      pdfdata.forEach((player, index) => {
        console.log('player', player.detail);
        //  console.log('player info')
        //  console.log(player)
        if (player.isnonplay == 1) {
          return null;
        }

        if (count2 == 0) {
          if (orderby2 == 2) {
            //  console.log('catdata')
            //  console.log(catdata)
            var catname = catdata?.filter((ct) => ct.cid == player.catid)[0].cname
            let clen = catname.length * 2
            doc.text(catname.toUpperCase(), 95 - clen / 2, 35);
            doc.setFontSize(8);
            doc.text('PLAYER LIST', 92, 35 + 5);
            doc.setFontSize(16);

          }
          if (orderby2 == 3) {

            var teamname = dataTeam.filter((tm) => tm.tid == player.tmid)[0].name;
            let tlen = teamname.length * 2
            doc.text(teamname.toUpperCase(), 95 - tlen / 2, 35);
          }

        }


        if (orderby2 == 2) {
          if (dumcatid !== player.catid) {
            // //  console.log("cat change ")
            dumcatid = player.catid;
            counter = 0
            // x=10
            count2 = 0;

            doc.addPage();

            // if (orderby == 3 || orderby == 4) {

            doc.setFontSize(16);


            var catname = catdata.filter((ct) => ct.cid == player.catid)[0].cname
            // //  console.log('cathead')
            // //  console.log(catname)


            // }
            // let x = 10;
            // let y = 60;
            doc.addImage((aucmoredetail && aucmoredetail?.more[0]?.pdfbg) ? (aucmoredetail?.fpath + aucmoredetail?.more[0].pdfbg) : pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
            doc.addImage((aucmoredetail && aucmoredetail?.more[0]?.pdfbg) ? (aucmoredetail?.fpath + aucmoredetail?.more[0].pdfbg) : pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
            if (aucteambase64[0]) {
              doc.addImage(aucteambase64[0], 'JPEG', 10, 10, 40, 40);
              if (isspnshow && aucteambase64[1]) {
                doc.addImage(aucteambase64[1], 'JPEG', 160, 10, 40, 40);
              }
              else {
                doc.addImage(aucteambase64[0], 'JPEG', 160, 10, 40, 40);
              }
            }
            else {
              doc.addImage(auctiondefaultLogo, 'JPEG', 10, 10, 40, 40);
              doc.addImage(auctiondefaultLogo, 'JPEG', 160, 10, 40, 40);

            }
            doc.setDrawColor(72, 104, 153);
            doc.rect(9.5, 9.5, 41, 41);

            doc.setDrawColor(72, 104, 153);
            doc.rect(159.5, 9.5, 41, 41);

            if (fontcolor == 0) {
              doc.setTextColor(255, 255, 255);
            }
            else {
              doc.setTextColor(20, 14, 92);
            } doc.setFontSize(18);

            if (acname.length < 27) {

              let alen = acname.length * 4

              doc.text(acname.toUpperCase(), 105 - alen / 2, 18);
            }
            else {
              doc.setFontSize(15);

              var fstr = linechanger(acname, 27)
              let alen1 = fstr[0].length * 3.2

              doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 18);
              if (fstr[1].length <= 25) {
                doc.setFontSize(14);

                let alen2 = fstr[1].length * 2.9

                doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 24);
              } else {
                var fsstr = linechanger(fstr[1], 25);
                doc.setFontSize(14);

                let alen2 = fsstr[0].length * 2.9;
                let alen3 = fsstr[1].length * 2.9;
                doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 24);
                doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 30);

              }



            }
            doc.setFontSize(16);
            if (orderby2 == 3 || orderby2 == 2) {
              // doc.text('TEAM PLAYER LIST', 90, 45);

            } else {

              doc.text('AUCTION PLAYER LIST', 90, 40);
            }
            let clen = catname.length * 2;
            doc.text(catname.toUpperCase(), 95 - clen / 2, 35);
            doc.setFontSize(8);
            doc.text('PLAYER LIST', 92, 35 + 5);
            doc.setFontSize(16);
            x = 10;
            y = 60
          }
        }
        if (orderby2 == 3) {
          // //  console.log("team ki pdfff")

          if (dumtid !== player.tmid) {
            // //  console.log("team change hui")
            dumtid = player.tmid;
            counter = 0
            count2 = 0

            doc.addPage();
            // if (orderby == 3 || orderby == 4) {

            doc.setFontSize(16);


            var teamname = dataTeam.filter((tm) => tm.tid == player.tmid)[0].name
            // doc.addImage(aucteambase64[player.tmid], 'JPEG', 75, 35, 15, 15);


            doc.addImage((aucmoredetail && aucmoredetail?.more[0]?.pdfbg) ? (aucmoredetail?.fpath + aucmoredetail?.more[0].pdfbg) : pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
            doc.addImage((aucmoredetail && aucmoredetail?.more[0]?.pdfbg) ? (aucmoredetail?.fpath + aucmoredetail?.more[0].pdfbg) : pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
            if (aucteambase64[0]) {
              if (isspnshow && aucteambase64[1]) {
                doc.addImage(aucteambase64[1], 'JPEG', 160, 10, 40, 40);

              }
              else {

                doc.addImage(aucteambase64[0], 'JPEG', 160, 10, 40, 40);
              }
            }
            else {
              doc.addImage(auctiondefaultLogo, 'JPEG', 160, 10, 40, 40);

            }
            if (aucteambase64[player.tmid]) {
              doc.addImage(aucteambase64[player.tmid], 'JPEG', 10, 10, 40, 40);

            } else {
              doc.addImage(teamdefaultLogo, 'JPEG', 10, 10, 40, 40);

            }
            doc.setDrawColor(72, 104, 153);
            doc.rect(9.5, 9.5, 41, 41);

            doc.setDrawColor(72, 104, 153);
            doc.rect(159.5, 9.5, 41, 41);

            if (fontcolor == 0) {
              doc.setTextColor(255, 255, 255);
            }
            else {
              doc.setTextColor(20, 14, 92);
            } doc.setFontSize(18);

            if (acname.length < 27) {

              let alen = acname.length * 4

              doc.text(acname.toUpperCase(), 105 - alen / 2, 18);
            }
            else {
              doc.setFontSize(15);

              var fstr = linechanger(acname, 27)
              let alen1 = fstr[0].length * 3.2

              doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 18);
              if (fstr[1].length <= 25) {
                doc.setFontSize(14);

                let alen2 = fstr[1].length * 2.9

                doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 24);
              } else {
                var fsstr = linechanger(fstr[1], 25);
                doc.setFontSize(14);

                let alen2 = fsstr[0].length * 2.9;
                let alen3 = fsstr[1].length * 2.9;
                doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 24);
                doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 30);

              }
            }
            doc.setFontSize(10);

            // doc.text('TEAM PLAYER LIST', 88, 45);
            doc.setFontSize(16);
            let tlen = teamname.length * 2

            doc.text(teamname, 95 - tlen / 2, 35);
            // doc.addImage(auctiondefaultLogo, 'JPEG', 75, 45, 20, 20);
            x = 10;
            y = 60;
          }
        }
        if (column == 2) {
          if (counter % 2 && counter != 0) {
            x = x + rightbox

          }
          else if (counter != 0) {
            y = y + bottombox
            x = 10;
          }
        }
        else if (column == 3) {
          if (counter % 3 && counter != 0) {
            x = x + rightbox

          }
          else if (counter != 0) {
            y = y + bottombox
            x = 10;
            // //  console.log("x to 0")
          }
        }



        // doc.setFillColor(255, 255, 255);

        doc.setDrawColor(232, 192, 84);

        doc.rect(x - 1, y - 1, rectwide, reactheight);



        // doc.setFillColor(5, 26, 66);

        // doc.rect(x - 1, y - 1, rectwide, reactheight, 'F');





        var imgindex = pldata?.list?.findIndex(item => item.pid === player.pid);

        doc.setDrawColor(252, 151, 28);
        doc.setFillColor(252, 151, 28);

        doc.rect(x - .5, y - .5, imgwidth + 1, imgheight + 1, 'F');
        if (base64Images[imgindex]) {
          doc.addImage(base64Images[imgindex], 'PNG', x, y, imgwidth, imgheight);
        }
        else {
          doc.addImage(playerdefaultLogo, 'PNG', x, y, imgwidth, imgheight);
        }

        doc.setFillColor(252, 151, 28);

        doc.rect(x - 2, y - 2, 4.5, 4.5, 'F');



        doc.setFontSize(nameagefont);
        doc.setFont('helvetica', 'bold');
        //  console.log('player name')
        //  console.log(player.pname)
        // if (player.pname.length > 20) {
        //   doc.setFontSize(nameagefont - 1);

        //   doc.text(player.pname.slice(0, 20).toUpperCase() + '...', x + namex, y + namey - 1);
        // }
        // else if (player.pname.length > 18) {
        //   doc.text(player.pname.slice(0, 18).toUpperCase() + '...', x + namex, y + namey - 1);

        // }
        // else {
        //   doc.text(player.pname.toUpperCase(), x + namex, y + namey - 1);
        // }
        if (player.pname.length > 20) {
          doc.setFontSize(6);
        }
        else {
          doc.setFontSize(8);
        }
        doc.text(player.pname.toUpperCase(), x + namex, y + namey - 1);
        doc.setFontSize(10);


        if (isplnoshow) {
          if (player.pcode.length == 1) {

            doc.text(player.pcode, x - .9, y + 1.3);
          }
          else if (player.pcode.length == 2) {
            doc.setFontSize(8.5);

            doc.text(player.pcode, x - 1.6, y + 1.3);
            doc.setFontSize(10);

          }
          else if (player.pcode.length == 3) {
            doc.setFontSize(7);
            doc.text(player.pcode, x - 1.8, y + 1.3); y
            doc.setFontSize(10);

          }

        }



        doc.setFontSize(nameagefont);

        doc.setFont('helvetica', 'normal');
        //Player age
        if (player.age !== "0") {
          doc.setFontSize(6);
          // if (isplnoshow) {
          //   doc.text(`AGE: ${player.age} YR`, x + plnox + 4 + player.pcode.length, y + agey - 2.1);

          // }
          // else {

          doc.text(`AGE: ${player.age} YR`, x + plnox, y + agey - 1.1);
          // }
        }
        if (ismobnoshow && player.mob) {
          doc.setFontSize(6);

          doc.addImage(tele, 'PNG', x + plnox + 20, y + agey - 4.5, 2.5, 2.5);
          doc.text(player.mob, x + plnox + 23, y + agey - 2.1);
        }
        doc.setTextColor(222, 235, 52);
        var ym = 3;
        if (player.age == '0') {

          var ym = 0;
        }

        // console.log('///////////isval show........')
        // console.log(isvalshow)
        if (orderby2 == 3 && isvalshow && player.tmid != "0" && player.tmid != "") {
          doc.setFontSize(10);
          if (fontcolor == 0) {
            doc.setTextColor(222, 235, 52);
          }
          else {
            doc.setTextColor(12, 79, 17);

          }
          if (currentauc.isdecm == '1') {

            doc.text(parseFloat(player.points).toFixed(2), x + plnox, y + agey + ym - 1);
            var temppx = player.points.length * 1.5

          }
          else {
            doc.text(String(parseInt(player.points)), x + plnox, y + agey + ym - 1);
            var temppx = String(parseInt(player.points)).length * 2


          }
          doc.setFontSize(6);
          if (currentauc?.unit != "" && currentauc?.unit != null) {
            doc.text(currentauc.unit + " POINTS", x + plnox + temppx, y + agey + ym - 1.5);

          }
          else {
            doc.text("POINTS", x + plnox + temppx + 1, y + agey + ym - 1.5);
          }
          // doc.text("Team :", x + plnox + temppx + 1, y + agey + ym - 1.5);
          if (fontcolor == 0) {
            doc.setTextColor(255, 255, 255);
          }
          else {
            doc.setTextColor(20, 14, 92);
          } if (colno == 1) {
            ym += 4.5;
          }
          else {
            ym += 3;

          }
        }
        if (fontcolor == 0) {
          doc.setTextColor(255, 255, 255);
        }
        else {
          doc.setTextColor(20, 14, 92);
        } doc.setFontSize(6);



        if (isvalshow && player.tmid != '0') {

          doc.text('SOLD TO :', x + plnox, y + agey + ym - 1);
          var pteam = dataTeam.filter((team) => team.tid == player.tmid)[0].name
          doc.text(pteam.toUpperCase(), x + plnox + 11, y + agey + ym - 1);
          ym += 2.2;
          // doc.addImage(soldstamp, 'JPEG', x + plnox + 27, y + agey + ym - 10, 10, 10);
        }
        if (isownershow && player.isowner != '0' && player.ownertag != '0') {
          doc.setFontSize(6);
          doc.setTextColor(222, 235, 52);

          var tag = '';
          if (player.ownertag == 1) {
            tag = 'Owner';
          }
          else if (player.ownertag == '2') {
            tag = 'Co-owner';
          }
          else if (player.ownertag == '3') {
            tag = 'Icon'
          }
          doc.text(tag, x + plnox, y + agey + ym - 1);
          ym += 2.2;
        }
        if (fontcolor == 0) {
          doc.setTextColor(255, 255, 255);
        }
        else {
          doc.setTextColor(20, 14, 92);
        }
        if (player.catid !== "0" && player.catid !== null && iscatshow) {
          doc.setFontSize(6);
          //  console.log("New player")


          var catname = catdata.filter((ct) => ct.cid == player.catid)[0]?.cname
          //  console.log('cats')
          //  console.log(cats)
          if (catname) {

            doc.text(catname.toUpperCase(), x + plnox, y + agey + ym - 1);
          }



          // doc.text('Base price : '+ player.base + ' ' + isunit, x + plnox, y + agey + ym - 1);
          // //  console.log(y + agey + ym - 1)
          ym += 2.2;
        }
        if (isbasePriceShow) {
          //  console.log('player is')
          //  console.log(player)
          var isunit = ''
          if (aucdata.list[0].unit != "" && aucdata.list[0].unit != null) {
            isunit = aucdata.list[0].unit
          }
          var cats = catdata.filter((ct) => ct.cid == player.catid)[0]
          // console.log('cats is')
          // console.log(cats)

          if (player.base != '' && player.base != null && player.base != '0.00') {
            // console.log('player base')  
            doc.text('Base price : ' + parseFloat(player.base).toFixed(currentauc.isdecm) + ' ' + isunit, x + plnox, y + agey + ym - 1);
          }
          else if (cats?.mbid !== '' && cats?.mbid != '0' && cats?.mbid != '0.00') {
            // console.log('cats mbid from cat')
            doc.text('Base price : ' + parseFloat(cats.mbid).toFixed(currentauc.isdecm) + ' ' + isunit, x + plnox, y + agey + ym - 1);

          }
          else if (aucminbid != '' && aucminbid != '0.00' && aucminbid != null) {
            // console.log('aucminbid')
            doc.text('Base price : ' + parseFloat(aucminbid).toFixed(currentauc.isdecm) + ' ' + isunit, x + plnox, y + agey + ym - 1);

          }
          // else if()
          ym += 2.2;
        }
        if (fontcolor == 0) {

          doc.setTextColor(232, 209, 188);
        }
        else {

          doc.setTextColor(22, 14, 117);
        }

        if (istshirtshow && player.tshirt !== "" && player.tshirt !== null) {
          // //  console.log(player.pname)
          // //  console.log(player.name)
          istshirtshow && doc.setFontSize(5);

          doc.text('T-' + player.tshirt, x + plnox, y + agey + ym - 1);
          ym += 2.2;

        }

        doc.setFontSize(5.6);

        // doc.text(player.spcf1.toUpperCase(), x + spcfx, y + agey + ym - 1);

        if (player.spcf1 && player.spcf1 != '' && player.spcf1 != null && isspec1) {
          if (player.spcf1.length <= 28) {
            doc.text(player.spcf1.toUpperCase(), x + spcfx, y + agey + ym - 1);
          } else {

            doc.setFontSize(5);

            var fstr = linechanger(player.spcf1, 29)

            doc.text(fstr[0].toUpperCase(), x + spcfx, y + agey + ym - 1);
            ym += 1.5;
            doc.text(fstr[1].toUpperCase(), x + spcfx, y + agey + ym - 1);
          }
          ym += 2.2;
        }

        //  console.log("spcf2 me aaya")
        if (player.spcf2 && isspec2) {
          if (player.spcf2.length <= 28) {
            doc.text(player.spcf2.toUpperCase(), x + spcfx, y + agey + ym - 1);
          } else {

            doc.setFontSize(5);

            var fsstr = linechanger(player.spcf2, 29)

            doc.text(fsstr[0].toUpperCase(), x + spcfx, y + agey + ym - 1);
            ym += 1.5;
            doc.text(fsstr[1].toUpperCase(), x + spcfx, y + agey + ym - 1);
          }
          ym += 2.2;

        }
        if (player.spcf3 && isspec3) {
          if (player.spcf3.length <= 28) {
            doc.text(player.spcf3.toUpperCase(), x + spcfx, y + agey + ym - 1);
          } else {

            doc.setFontSize(4.5);

            var fsstr = linechanger(player.spcf3, 29)

            doc.text(fsstr[0].toUpperCase(), x + spcfx, y + agey + ym - 1);
            ym += 1.5;
            if (fsstr[1].length < 29) {

              doc.text(fsstr[1].toUpperCase(), x + spcfx, y + agey + ym - 1);
            } else {
              var fssstr = linechanger(fsstr[1], 29)
              doc.text(fssstr[0].toUpperCase(), x + spcfx, y + agey + ym - 1);
              ym += 1.5;
              doc.text(fssstr[1].toUpperCase(), x + spcfx, y + agey + ym - 1);

            }
          }
          ym += 2.2;

        }
        if (player.detail && isdetailshow) {
          if (player.detail.length <= 28) {
            doc.text(player.detail.toUpperCase(), x + spcfx, y + agey + ym - 1);
          } else {

            doc.setFontSize(4.5);

            var fsstr = linechanger(player.detail, 29)

            doc.text(fsstr[0].toUpperCase(), x + spcfx, y + agey + ym - 1);
            ym += 1.5;
            if (fsstr[1].length < 29) {

              doc.text(fsstr[1].toUpperCase(), x + spcfx, y + agey + ym - 1);
            } else {
              var fssstr = linechanger(fsstr[1], 29)
              doc.text(fssstr[0].toUpperCase(), x + spcfx, y + agey + ym - 1);
              ym += 1.5;
              doc.text(fssstr[1].toUpperCase(), x + spcfx, y + agey + ym - 1);

            }
          }
          ym += 2.2;

        }

        counter = counter + 1;
        count2 = count2 + 1

        if (fontcolor == 0) {
          doc.setTextColor(255, 255, 255);
        }
        else {
          doc.setTextColor(20, 14, 92);
        }
        if (count2 > perpage) {
          if (counter % (perpage + extra) == 0) {
            counter = 0
            doc.addPage();
            doc.addImage((aucmoredetail && aucmoredetail?.more[0]?.pdfbg) ? (aucmoredetail?.fpath + aucmoredetail?.more[0].pdfbg) : pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
            x = 10;
            y = 10
          }

        }
        else {
          if (counter % perpage == 0) {

            counter = 0
            doc.addPage();
            doc.addImage((aucmoredetail && aucmoredetail?.more[0]?.pdfbg) ? (aucmoredetail?.fpath + aucmoredetail?.more[0].pdfbg) : pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
            x = 10;
            y = 10
          }
        }

        plno += 1

      });


      setpdfclk(false)
      if (orderby2 == "" || orderby2 == 1) {

        doc.save(aid + "-" + acname.toUpperCase() + '_PLIST.pdf');
      }
      if (orderby2 == 2) {

        doc.save(aid + "-" + acname.toUpperCase() + '_PLIST_CATEGORY.pdf');
      }
      if (orderby2 == 3) {

        doc.save(aid + "-" + acname.toUpperCase() + '_PLIST_TEAM.pdf');
      }

    }
    else {
      alert("Data is empty !!")
    }

  }
  const firechange = (datasnap) => {
    //  console.log("firechange");
    //  console.log(datasnap);
    //  console.log(getpageData)

    if (datasnap.type == "4" && datasnap.upd == "1" && getpageData != 0) {
      let responsedata = {};
      responsedata = {
        responsedata: {
          path: getpageData.responsedata.path,
          aid: aid,
          list: [datasnap.detail, ...getpageData.responsedata.list],
        },
      };
      //  console.log(responsedata)
      setData(responsedata.responsedata)
      setplData(responsedata.responsedata)

      dispatch(playerlistData(responsedata));



    }
    if (datasnap.type == "4" && datasnap.upd == "2") {
      //  console.log("firechange edit")
      if (getpageData != 0) {
        const updateitem = getpageData.responsedata.list.filter(
          (ele, ind) => {
            //  console.log('datasnap')
            //  console.log(datasnap)
            if (ele.pid == datasnap.id) {
              // values.age,
              ele.age = datasnap.detail.age
              ele.base = datasnap.detail.base,
                ele.catid = datasnap.detail.catid,
                ele.fname = datasnap.detail.fname,
                ele.icons = datasnap.detail.icons,
                ele.detail = datasnap.detail.detail,
                ele.isnonplay = datasnap.detail.isnonplay,
                ele.isowner = datasnap.detail.isowner,
                ele.jrnm = datasnap.detail.jrnm,
                ele.jrno = datasnap.detail.jrno,
                ele.img = datasnap.detail.img,
                ele.mob = datasnap.detail.mob,
                ele.ownertag = datasnap.detail.ownertag,
                ele.pcode = datasnap.detail.pcode,
                ele.pid = datasnap.detail.pid,
                ele.pname = datasnap.detail.pname,
                ele.spcf1 = datasnap.detail.spcf1,
                ele.spcf2 = datasnap.detail.spcf2,
                ele.spcf3 = datasnap.detail.spcf3,
                ele.trouser = datasnap.detail.trouser,
                ele.tshirt = datasnap.detail.tshirt

            }

            return ele;
          }
        );
        //  console.log(updateitem)
        let responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            aid: aid,
            list: updateitem,
          },
        };
        setData(responsedata.responsedata)
        setplData(responsedata.responsedata)
        dispatch(playerlistData(responsedata));

      }


    }
    if (datasnap.type == "4" && datasnap.upd == "3") {
      //  console.log("firechange del")
      if (getpageData != 0) {
        const updateitem = getpageData.responsedata.list.filter((ele, ind) => {
          return ele.pid != datasnap.id;
        });
        let responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            aid: aid,
            list: updateitem,
          },
        };
        setData(responsedata.responsedata);
        setplData(responsedata.responsedata);

        dispatch(playerlistData(responsedata));

      }

    }
    if (datasnap.type == "1" && datasnap.upd == "3") {
      if (getaucpageData != 0) {
        const updateitem = getaucpageData.responsedata.list.filter((ele) => ele.aid != datasnap.id)

        let responsedata = {
          responsedata: {
            path: getaucpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));
      }
      history.push(BASE_PATH + 'my-auction')
    }
    if ((datasnap.type == "1" && datasnap.upd == "4") || (datasnap.type == "3" && datasnap.upd == "4")) {
      setData(getpageData.responsedata)
      setplData(getpageData.responsedata)
    }
  }
  function plfilter() {
    // //  console.log(filter.selectedStatus)
    //  console.log(filter)
    if (filter.searchText == "" && filter.selectedStatus == "" && filter.selectedCategory == "1") {
      // //  console.log("return ja rha")
      return 0

    }
    else {
      dispatch(playerfilter(filter))




      const filteredPlayers = getpageData.responsedata.list.filter((player) => {
        const matchesSearchText = (
          isNaN(filter.searchText) && player.pname.toLowerCase().includes(filter.searchText.toLowerCase()) ||
          filter.searchText.length < 7 && player.pcode.toString().includes(filter.searchText) ||
          filter.searchText.length > 7 && player.mob && player.mob.includes(filter.searchText)
        );
        const matchesStatus = (
          (filter.selectedStatus == '5' && player.isskiped == 1) ||
          (filter.selectedStatus == '6' && player.isowner != 0) ||
          (filter.selectedStatus == '4' && player.isfreez == 1) ||
          (filter.selectedStatus == '2' && player.tmid == 0) ||
          (filter.selectedStatus == '3' && player.tmid > 0) ||
          (filter.selectedStatus == "1") ||
          filter.selectedStatus == ""
        );

        const matchesCategory = (filter.selectedCategory !== "1" && player.catid === filter.selectedCategory) || filter.selectedCategory == "1";

        return matchesSearchText && matchesStatus && matchesCategory;
      });
      var responsedata1 = {
        'aid': getpageData.responsedata.aid,
        'path': getpageData.responsedata.path,
        'list': filteredPlayers

      }
      //  console.log(responsedata1)
      setData(responsedata1)
    }
  }
  useEffect(() => {
    //  console.log('data badla h')
    //  console.log(pldata)

  }, [pldata])

  useEffect(() => {
    localStorage.removeItem('isFirstMount');

    if (aucdata == 0) {
      fetchaucData()

    }
    // if(getteampageData==0){
    fetchTeamData()
    // }
    // fetchData();
    if (getpageData == 0) {
      fetchData();
    } else {
      //  console.log('setting players...')
      if (getpageData.responsedata.aid == aid) {
        setData(getpageData.responsedata);
        setplData(getpageData.responsedata);
      } else {
        let responsedata = getpageData.responsedata;
        responsedata.list = [];
        setData(responsedata);
        setplData(responsedata);
        fetchData(0);
      }
    }
    if (getteampageData == 0) {
      fetchTeamData();

    }
    if (getcatpageData == 0) {

      fetchcatData();
    }

    setRenderCount((prevCount) => prevCount + 1);
    if (aucmoredetail) {

      if (aucmoredetail.spn?.length > 0) {
        setsponsorlogo(aucmoredetail.spath + aucmoredetail.spn[0].logo + '?c')
      }
    }
  }, []);
  useEffect(() => {
    if (upddata !== null) {
      if (upddata !== isfirsttime) {
        firechange(upddata);
        if (upddata.type == "4") {
          dispatch(setisfirsttime(upddata));
        }
      }
    }
  }, [upddata]);
  const fileToDataUri = (image) => {
    return new Promise((res) => {
      const reader = new FileReader();
      const { type, name, size } = image;
      reader.addEventListener('load', () => {
        res({
          base64: reader.result,
          name: name,
          type,
          size: size,
        })
      });
      reader.readAsDataURL(image);
    })
  }

  const base64 = async () => {



  };


  useEffect(() => {
    if (getfilters != 0) {
      //  console.log('runningfilters')
      plfilter();
    }
    plfilter();
  }, [filter])

  function getpdf() {
    setpdfclk(true)
    // history.push('/players-pdf')
  }
  function excelclk() {
    setisexcelclk(true)
    // history.push('/players-pdf')
  }

  function exceldownload() {
    if (exceltype == 1 || exceltype == "") {
      var ar3 = []
      var ar4 = []
      // ar4.push(ele.id)
      { isexcelplno && ar4.push("P_no") }
      ar4.push("Name")
      { isexcelmob && ar4.push("Mobile") }
      { isexcelage && ar4.push("Age") }
      { isexceldob && ar4.push("Dob") }
      { isexcelcat && ar4.push("Category") }
      { isexcelsp1 && ar4.push("Specification 1") }
      { isexcelsp2 && ar4.push("Specification 2") }
      { isexcelsp3 && ar4.push("Specification 3") }
      { isexceldetail && ar4.push("Detail") }
      { isexceltshirt && ar4.push("Tshirt") }
      { isexceltrouser && ar4.push("Trouser") }
      { isexceljname && ar4.push("Jersey_name") }
      { isexceljno && ar4.push("Jersey_no") }
      { isexcelbasebid && ar4.push("Base_bid") }
      { isexcelimage && ar4.push("Image") }
      if (data?.list[0].runwkt !== null && data?.list[0].runwkt !== '') {
        var runwkt1 = JSON.parse(data?.list[0].runwkt)
        for (const key in runwkt1) {
          // //  console.log('fields val')
          // //  console.log(runwkt1[key].V)
          ar4.push(runwkt1[key].N);
        }
      }
      ar4.push()
      // ar3.push(ar2)
      // ar4.push("About")
      ar3.push(ar4)
      // var plcount=0;
      var data2 = data.list.forEach(ele => {
        //  console.log(ele)
        var ar2 = []
        // ar2.push(ele.id)
        // if(ele.tmid=="0"){
        // plcount+=1

        { isexcelplno && ar2.push(ele.pcode) }
        ar2.push(ele.pname)
        { isexcelmob && ar2.push(ele.mob) }
        { isexcelage && ar2.push((ele.age !== "0" && ele.age !== "") ? ele.age : "-") }
        { isexceldob && ar2.push(ele.dob) }
        if (isexcelcat == true) {
          if (ele.catid !== "0" && ele.catid !== "" && ele.catid !== undefined) {

            catdata.filter((item) => {
              if (item.cid == ele.catid) {
                ar2.push(item.cname)
              }

            })
          }
          else {
            ar2.push('-')
          }
        }

        { isexcelsp1 && ar2.push(ele.spcf1 || "-") }
        { isexcelsp2 && ar2.push(ele.spcf2 || "-") }
        { isexcelsp3 && ar2.push(ele.spcf3 || "-") }
        { isexceldetail && ar2.push(ele.detail || "-") }
        { isexceltshirt && ar2.push(ele.tshirt || "-") }
        { isexceltrouser && ar2.push(ele.trouser || "-") }
        { isexceljname && ar2.push(ele.jrnm || "-") }
        { isexceljno && ar2.push(ele.jrno || "-") }
        { isexcelbasebid && ar2.push(ele.base || "-") }
        { isexcelimage && ar2.push(data.path + ele.img) }

        if (ele.runwkt !== null && ele.runwkt !== "") {
          var runwkt1 = JSON.parse(ele.runwkt)
          for (const key in runwkt1) {
            //  console.log('fields val')
            //  console.log(runwkt1[key].V)
            ar2.push(runwkt1[key].V);
          }
        }
        ar2.push()
        ar3.push(ar2)
        // }

      });

    }
    else if (exceltype == 2) {
      var ar3 = []
      var ar4 = []
      // ar4.push(ele.id)
      ar4.push("S_no")
      { isexcelplno && ar4.push("P_no") }
      ar4.push("Name")
      { isexcelmob && ar4.push("Mobile") }
      { isexcelage && ar4.push("Age") }
      { isexceldob && ar4.push("Dob") }
      { isexcelcat && ar4.push("Category") }
      { isexcelsp1 && ar4.push("Specification 1") }
      { isexcelsp2 && ar4.push("Specification 2") }
      { isexcelsp3 && ar4.push("Specification 3") }
      // ar4.push("WK")
      { isexceldetail && ar4.push("Detail") }
      { isexceltshirt && ar4.push("Tshirt") }
      { isexceltrouser && ar4.push("Trouser") }
      { isexceljname && ar4.push("Jersey_name") }
      { isexceljno && ar4.push("Jersey_no") }
      { isexcelbasebid && ar4.push("Base_bid") }
      { isexcelimage && ar4.push("Image") }
      ar3.push(ar4)
      var plcount = 0;

      var data2 = data.list.forEach(ele => {
        var ar2 = []
        // ar2.push(ele.id)
        if (ele.tmid == "0") {
          plcount += 1

          ar2.push(plcount)
          { isexcelplno && ar2.push(ele.pcode) }
          ar2.push(ele.pname)
          { isexcelmob && ar2.push(ele.mob) }
          { isexcelage && ar2.push((ele.age !== "0" && ele.age !== "") ? ele.age : "-") }
          { isexceldob && ar2.push(ele.dob || '-') }
          if (isexcelcat == true) {
            if (ele.catid !== "0" && ele.catid !== "" && ele.catid !== undefined) {

              catdata.filter((item) => {
                if (item.cid == ele.catid) {
                  ar2.push(item.cname)
                }

              })
            }
            else {
              ar2.push('-')
            }
          }

          { isexcelsp1 && ar2.push(ele.spcf1 || "-") }
          { isexcelsp2 && ar2.push(ele.spcf2 || "-") }
          { isexcelsp3 && ar2.push(ele.spcf3 || "-") }
          { isexceldetail && ar2.push(ele.detail || "-") }
          { isexceltshirt && ar2.push(ele.tshirt || "-") }
          { isexceltrouser && ar2.push(ele.trouser || "-") }
          { isexceljname && ar2.push(ele.jrnm || "-") }
          { isexceljno && ar2.push(ele.jrno || "-") }
          { isexcelbasebid && ar2.push(ele.base || "-") }
          { isexcelimage && ar2.push(data.path + ele.img) }
          ar3.push(ar2)
        }

      });

    }
    else if (exceltype == 3) {
      fetchTeamData();
      fetchcatData();
      fetchData();
      var ar3 = []
      var ar4 = []
      ar4.push("SNo")
      { isexcelteam && ar4.push("Team") }
      { isexcelplno && ar4.push("P_No") }
      ar4.push("Name")
      { isexcelpoints && ar4.push("Points") }
      { isexcelmob && ar4.push("Mobile") }
      { isexcelage && ar4.push("Age") }
      { isexceldob && ar4.push("Dob") }
      { isexcelcat && ar4.push("Category") }
      { isexcelsp1 && ar4.push("Specification 1") }
      { isexcelsp2 && ar4.push("Specification 2") }
      { isexcelsp3 && ar4.push("Specification 3") }
      { isexcelfname && ar4.push("FName") }
      // ar4.push("Info")
      { isexceldetail && ar4.push("Detail") }
      { isexceltshirt && ar4.push("TShirt") }
      { isexceltrouser && ar4.push("Trouser") }
      { isexceljname && ar4.push("Jersey_Name") }
      { isexceljno && ar4.push("Jersey_No.") }
      { isexcelbasebid && ar4.push("Base_bid") }
      { isexcelimage && ar4.push("Image") }
      ar3.push(ar4)

      dataTeam.forEach((tm) => {
        var teamwise = []
        teamwise = data.list.filter((dt) => dt.tmid == tm.tid)
        var sno = 1;
        teamwise.forEach((ele) => {
          //  console.log(ele)
          var ar2 = []
          ar2.push(sno)
          { isexcelteam && ar2.push(tm.name) }
          { isexcelplno && ar2.push(ele.pcode) }
          ar2.push(ele.pname)
          { isexcelpoints && ar2.push(ele.points) }
          { isexcelmob && ar2.push(ele.mob || "-") }
          { isexcelage && ar2.push((ele.age !== "0" && ele.age !== "") ? ele.age : "-") }
          { isexceldob && ar2.push(ele.dob) }
          if (isexcelcat == true) {
            if (ele.catid !== "0" && ele.catid !== "" && ele.catid !== undefined) {
              //  console.log(ele.catid)
              //  console.log(catdata)
              var catname = catdata.filter((ct) => ct.cid == ele.catid)[0].cname
              ar2.push(catname)
            } else {
              ar2.push("-");
            }
          }

          { isexcelsp1 && ar2.push(ele.spcf1) }
          { isexcelsp2 && ar2.push(ele.spcf2) }
          { isexcelsp3 && ar2.push(ele.spcf3) }
          { isexcelfname && ar2.push(ele.fname || "-") }
          { isexceldetail && ar2.push(ele.detail || "-") }
          { isexceltshirt && ar2.push(ele.tshirt || "-") }
          { isexceltrouser && ar2.push(ele.trouser || "-") }
          { isexceljname && ar2.push(ele.jrnm || "-") }
          { isexceljno && ar2.push(ele.jrno || "-") }
          { isexcelbasebid && ar2.push(ele.base) }

          { isexcelimage && ar2.push(data.path + ele.img) }
          ar3.push(ar2)
          sno += 1;
        })

      });


    }

    const ws = XLSX.utils.aoa_to_sheet(ar3);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const excelBlob = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i !== s.length; i++) {
        view[i] = s.charCodeAt(i) & 0xFF;
      }
      return buf;
    }
    const blob = new Blob([s2ab(excelBlob)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });


    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    if (exceltype == 1) {
      a.download = aid + "-" + acname + "_PLIST.xlsx";
    }
    else if (exceltype == 2) {
      a.download = aid + "-" + acname + "_PLIST_UNSOLD.xlsx";
    }
    else if (exceltype == 3) {
      a.download = aid + "-" + acname + "_PLIST_FINAL.xlsx";
    }
    else {
      a.download = aid + "-" + acname + "_PLIST.xlsx";
    }
    a.click();
    var data1 = {};
    const db = getDatabase();

    data1['work11'] = 3;
    update(ref(db, 'auction/info/datastatus/' + aid), data1);
    var workhistory = {};
    var currentTime = new Date();  // Store the current time in a variable

    workhistory['worktyp'] = 'work11';
    workhistory['id'] = admin_id;
    workhistory['name'] = admin_name;
    workhistory['timestamp'] = currentTime.toISOString();
    workhistory['aname'] = acname;
    workhistory['aid'] = aid;

    push(ref(db, 'auction/info/workhistory'), workhistory);

    URL.revokeObjectURL(url);
  }
  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilter({ ...filter, [name]: value });
  };


  function setdata() {
    if (issetdata == false) {
      setissetdata(true)

    }
    else {
      setissetdata(false)

    }
  }
  function pdfcls() {
    setpdfclk(false)
  }
  function excelcls() {
    setisexcelclk(false)
  }
  function setorderdata(v) {
    setfilorder(v)
    // //  console.log(pldata.list)
    if (v == "2") {

      var ordereddata = data.list.sort((a, b) => {

        return a.pname.localeCompare(b.pname, undefined, { sensitivity: 'case' });

      });

    }
    else if (v == "" || v == "1") {
      // //  console.log("ordereddata")
      // //  console.log(getpageData.responsedata.list)
      var ordereddata = data.list.sort((a, b) => {
        return a.pcode - b.pcode;
      })

    }

  }
  function onKeyDownHandler(e) {
    if (e.keyCode === 13) {
      plfilter()
    }
  };

  const convertImageToBase64 = (img, index) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = img.width;
    canvas.height = img.height;
    // ctx.imageSmoothingEnabled = false; // Disable image smoothing
    ctx.drawImage(img, 0, 0, img.width, img.height);

    const base64Data = canvas.toDataURL('image/png');

    if (base64Data) {
      const newarr = base64Images;
      newarr[index] = base64Data
      setBase64Images(newarr);

    }
    const canvas2 = document.createElement('canvas');
    const ctx2 = canvas2.getContext('2d');
    canvas2.width = img.width;
    canvas2.height = img.height;
    ctx2.arc(img.width / 2, img.width / 2, img.width / 2, 0, Math.PI * 2, true);
    ctx2.clip();
    ctx2.drawImage(img, 0, 0, img.width, img.height);
    const roundbase64Data = canvas2.toDataURL('image/png', 1);
    if (roundbase64Data) {

      const newarr2 = roundbase64Images;
      newarr2[index] = roundbase64Data

      setroundBase64Images(newarr2);


    }

  };
  const convertaucteamtobase64 = (img, index) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = img.width;
    canvas.height = img.height;

    ctx.drawImage(img, 0, 0, img.width, img.height);


    const base64Data2 = canvas.toDataURL('image/png');

    if (base64Data2) {

      const newarr2 = aucteambase64;
      newarr2[index] = base64Data2
      //  console.log(newarr2)
      setaucteambase64(newarr2);

    }

  };
  const handleImageLoad = (index) => {

    return () => {

      convertImageToBase64(imageRefs.current[index], index);


    };
  };
  const handleaucimgload = (index) => {

    return () => {

      convertaucteamtobase64(aucteamrefs.current[index], index);


    };
  };

  const createClippingPath = (width, height, radius) => {
    const path = new Path();
    path.moveTo(radius, 0);
    path.arcTo(width - radius, 0, width, radius, radius);
    path.arcTo(width, height - radius, width - radius, height, radius);
    path.arcTo(radius, height, 0, height - radius, radius);
    path.arcTo(0, radius, radius, 0, radius);
    path.closePath();
    return path;
  };
  function linechanger(str, count) {
    var plsp = str.split(" ")
    let plsplen = 0;
    let whichsp = 0;
    let firststr = "";
    let secstr = "";
    for (let i = 0; i < plsp.length; i++) {
      plsplen += plsp[i].length;

      if (plsplen > count) {

        break;
      }
      whichsp += 1

    }
    var linearr = []
    for (let y = 0; y < whichsp; y++) {
      if (firststr !== '') {
        firststr += " "
      }
      firststr += plsp[y];
    }
    linearr.push(firststr)

    for (let z = whichsp; z < plsp.length; z++) {
      if (secstr !== '') {
        secstr += " "
      }
      secstr += plsp[z];
    }
    linearr.push(secstr)
    return linearr
  }
  const tagwisedownload = (playerlist) => {

    const doc = new jsPDF('p', 'mm', 'a4');

    ///////////// working area///////////////////

    //  console.log('tagwise data')
    //  console.log(data)
    var tagwisepdf = []
    var tagplayercount = []

    //  console.log('dataTeam')
    //  console.log(dataTeam)
    dataTeam.forEach((tm) => {
      var teamwise = []
      var teamwisefiltered = []
      teamwise = data.list.filter((dt) => dt.tmid == tm.tid)
      //  console.log('team wise entry')
      //  console.log(teamwise)
      if (isownertagselect) {
        teamwisefiltered = [...teamwisefiltered, ...teamwise.filter((ele) => ele.ownertag == '1')]
      }
      if (iscoownertagselect) {
        teamwisefiltered = [...teamwisefiltered, ...teamwise.filter((ele) => ele.ownertag == '2')]
      }
      if (iscaptaintagselect) {
        teamwisefiltered = [...teamwisefiltered, ...teamwise.filter((ele) => ele.ownertag == '3')]
      }
      if (isicontagselect) {
        teamwisefiltered = [...teamwisefiltered, ...teamwise.filter((ele) => ele.ownertag == '4')]
      }
      if (isretaintagselect) {
        teamwisefiltered = [...teamwisefiltered, ...teamwise.filter((ele) => ele.ownertag == '5')]
      }
      //  console.log('teamwisefiltered')
      //  console.log(teamwisefiltered)
      tagplayercount = [...tagplayercount, teamwisefiltered.length]
      tagwisepdf = [...tagwisepdf, ...teamwisefiltered]

    })

    //  console.log('final tagwise pdfdata')
    //  console.log(tagwisepdf)
    //  console.log(tagplayercount)

    doc.addImage(pdfbg, 'JPEG', 0, 0, 210, 297); // Position (x=0, y=0), Size (210mm x 297mm for A4)
    doc.addImage(pdfauctiontitlebg, 'JPEG', 40, 10, 130, 20);
    if (aucteambase64[0]) {
      doc.addImage(aucteambase64[0], 'JPEG', 10, 10, 20, 20);
      doc.addImage(aucteambase64[0], 'JPEG', 175, 10, 20, 20);
    }
    else {
      doc.addImage(auctiondefaultLogo, 'JPEG', 10, 10, 20, 20);
      doc.addImage(auctiondefaultLogo, 'JPEG', 175, 10, 20, 20);

    }
    /////////////////Auction name/////////////////////
    doc.setTextColor(255, 255, 255);

    if (acname.length < 27) {
      let alen = acname.length * 3.5
      doc.text(acname.toUpperCase(), 105 - alen / 2, 22);
    }
    else {
      doc.setFontSize(15);

      var fstr = linechanger(acname, 27)
      let alen1 = fstr[0].length * 3.2

      doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 20);
      if (fstr[1].length <= 25) {
        doc.setFontSize(14);

        let alen2 = fstr[1].length * 2.9

        doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 25);
      } else {
        var fsstr = linechanger(fstr[1], 25);
        doc.setFontSize(14);

        let alen2 = fsstr[0].length * 2.9;
        let alen3 = fsstr[1].length * 2.9;
        doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 17);
        doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 24);

      }
    }
    doc.setFontSize(12);
    doc.setTextColor(237, 215, 12);
    doc.setFont('helvetica', 'bold');

    //////////////////////////////////////////////////

    /////////////////////////////////////////////////////////



    let centerX = 30;
    let centerY = 65;
    let imageSize = 17; // Size of the Image
    let teamX = 98; // Size of the Image
    let radius = imageSize / 2 + 3; // Radius of the arc
    let adjustCenter = imageSize / 2;

    var dumtid = tagwisepdf[0]?.tmid;
    let count = 0
    let teamcounter = 0
    let istwolane = false
    tagplayercount.map((ele) => {
      if (ele <= 2) {
        istwolane = true;
      }
    })
    if (istwolane) {
      centerX = 25
      teamX = 60
      centerY = 70
      imageSize = 23
    }

    if (tagplayercount[0] !== 0) {
      console.log('tagwisepdf[0]')
      console.log(tagwisepdf)
      console.log(tagplayercount)
      console.log(tagwisepdf[0])
      // console.log(tagwisepdf[0])
      var teamname = dataTeam.filter((tm) => tm.tid == tagwisepdf[0].tmid)[0].name;
      let tlen = teamname.length * 2
      doc.text(teamname.toUpperCase(), teamX - tlen / 2, centerY - 20);
    }
    console.log(tagwisepdf)

    tagwisepdf.map((player, index) => {
      outer: if (dumtid !== player.tmid) {
        dumtid = player.tmid;
        teamcounter += 1;
        count = 0;
        if ((teamcounter) % 6 == 0 && count == 0 && teamcounter != 0 && !istwolane) {

          break outer;

        }
        if ((teamcounter) % 10 == 0 && count == 0 && teamcounter != 0 && istwolane) {
          break outer;
        }
        doc.setFontSize(12);
        if (istwolane && teamcounter % 2 != 0) {
          teamX = 140;
          // centerX += 60
        }
        else if (istwolane && teamcounter % 2 == 0) {
          centerY += 48;
          teamX = 60;
        }
        else {
          centerY += 41;
        } doc.setFontSize(12);
        doc.setTextColor(237, 215, 12);
        doc.setFont('helvetica', 'bold');
        console.log('ggg')
        console.log(player.pname)
        console.log(player.tmid)
        console.log(dataTeam)
        var teamnamee = dataTeam.filter((tm) => tm.tid == player.tmid)[0].name
        console.log(teamnamee)
        let tlen = teamnamee.length * 2
        doc.text(teamnamee, teamX - tlen / 2, centerY - 20);
      }
      if (((teamcounter) % 6 == 0 && count == 0 && teamcounter != 0 && !istwolane) || ((teamcounter) % 10 == 0 && count == 0 && teamcounter != 0 && istwolane)) {
        centerY = 70
        //  console.log('inside add page/////')
        doc.addPage();
        doc.addImage(pdfbg, 'JPEG', 0, 0, 210, 297); // Position (x=0, y=0), Size (210mm x 297mm for A4)
        doc.addImage(pdfauctiontitlebg, 'JPEG', 50, 10, 110, 20);
        if (aucteambase64[0]) {
          doc.addImage(aucteambase64[0], 'JPEG', 10, 10, 20, 20);
          doc.addImage(aucteambase64[0], 'JPEG', 175, 10, 20, 20);
        }
        else {
          doc.addImage(auctiondefaultLogo, 'JPEG', 10, 10, 20, 20);
          doc.addImage(auctiondefaultLogo, 'JPEG', 175, 10, 20, 20);

        }
        /////////////////Auction name/////////////////////
        doc.setTextColor(255, 255, 255);

        if (acname.length < 27) {
          doc.setFontSize(17);
          let alen = acname.length * 3.5
          doc.text(acname.toUpperCase(), 105 - alen / 2, 22);
        }
        else {
          doc.setFontSize(15);

          var fstr = linechanger(acname, 27)
          let alen1 = fstr[0].length * 3.2

          doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 20);
          if (fstr[1].length <= 25) {
            doc.setFontSize(14);

            let alen2 = fstr[1].length * 2.9

            doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 25);
          } else {
            var fsstr = linechanger(fstr[1], 25);
            doc.setFontSize(14);

            let alen2 = fsstr[0].length * 2.9;
            let alen3 = fsstr[1].length * 2.9;
            doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 17);
            doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 24);

          }
        }
        doc.setFontSize(12);
        doc.setTextColor(237, 215, 12);
        doc.setFont('helvetica', 'bold');
        if (istwolane && teamcounter % 2 != 0) {
          teamX = 140
          // centerX += 60
        }
        else if (istwolane && teamcounter % 2 == 0) {
          teamX = 60
        }
        console.log('player.pname')
        console.log(player.pname)
        var teamname = dataTeam.filter((tm) => tm.tid == player.tmid)[0].name;
        console.log(teamname)
        let tlen = teamname.length * 2
        doc.text(teamname, teamX - tlen / 2, centerY - 20);

      }
      if (count == 0 && tagplayercount[teamcounter] == 1) {
        if (!istwolane) {
          centerX = 103;
          radius = imageSize / 2 + 3; //  Radius of the arc
          adjustCenter = imageSize / 2;
        }
        else if (istwolane && teamcounter % 2 != 0) {
          centerX = 145;
          radius = imageSize / 2 + 3; // Radius of the arc
          adjustCenter = imageSize / 2;
        }
        else if (istwolane && teamcounter % 2 == 0) {
          centerX = 145;
          radius = imageSize / 2 + 3; // Radius of the arc
          adjustCenter = imageSize / 2;
        }
      }
      else if (count == 0 && tagplayercount[teamcounter] == 2) {
        if (!istwolane) {

          centerX = 83;
          radius = imageSize / 2 + 3; // Radius of the arc
          adjustCenter = imageSize / 2;
        }
        else if (istwolane && teamcounter % 2 != 0) {
          centerX = 125;
          radius = imageSize / 2 + 3; // Radius of the arc
          adjustCenter = imageSize / 2;
        }
        else if (istwolane && teamcounter % 2 == 0) {
          centerX = 45;
          radius = imageSize / 2 + 3; // Radius of the arc
          adjustCenter = imageSize / 2;
        }
      }
      else if (count == 0 && tagplayercount[teamcounter] == 3) {
        centerX = 63;
        radius = imageSize / 2 + 3; // Radius of the arc
        adjustCenter = imageSize / 2;
      }
      else if (count == 0 && tagplayercount[teamcounter] == 4) {
        centerX = 45;
        radius = imageSize / 2 + 3; // Radius of the arc
        adjustCenter = imageSize / 2;
      }
      else if (count == 0 && tagplayercount[teamcounter] == 5) {
        centerX = 30;
        radius = imageSize / 2 + 3; // Radius of the arc
        adjustCenter = imageSize / 2;
      }
      doc.setDrawColor(165, 148, 247);
      doc.setLineWidth(1);
      doc.circle(centerX, centerY, imageSize / 2 + 0.2, 'S')
      doc.setDrawColor(170, 180, 227);
      doc.setLineWidth(0.3);
      doc.circle(centerX, centerY, imageSize / 2 + 1.8, 'S')
      // Player Image 
      console.log('player is ...')
      console.log(player.pname)
      const plingindex = data.list.findIndex((elem) => elem.pid === player.pid)
      console.log('center x is')
      console.log(centerX)
      doc.addImage(roundbase64Images[plingindex], 'jpeg', centerX - adjustCenter, centerY - adjustCenter, imageSize, imageSize);
      if (istwolane) {

        doc.addImage(tagbadge, 'PNG', centerX - adjustCenter - 8, centerY - adjustCenter + 20, 36, 6);
      } else {

        doc.addImage(tagbadge, 'PNG', centerX - adjustCenter - 6, centerY - adjustCenter + 14, 29, 6);
      }

      const text = player.pname; // Text to display
      let rta = 0;
      let tlength = text.length / 2;
      const angleOffset = -(Math.PI / 2) * ((tlength + 1) / 14); // Start from top of the circle (-90 degrees)    
      let falselength = 26; ///text.length

      doc.setFontSize(8);
      doc.setTextColor('#ffffff'); // White color or adjust based on background
      doc.setFont("Courier", "normal");

      for (let i = 0; i < text.length; i++) {
        rta = (tlength - 0.5 - i) * 7;
        const char = text[i];
        const angle = angleOffset + (i - (falselength - 1) / 2) * (Math.PI / falselength); // Distribute letters along the arc
        const rotationAngle = angle + Math.PI / 2;
        const x = centerX + radius * Math.cos(angle);
        const y = centerY + radius * Math.sin(angle);
        doc.text(char, x, y, null, rta); // Draw each character
      }
      // doc.setTextColor('#d97c11')
      doc.setFont("Courier", "bold");
      doc.setFontSize(7);
      const tagname = player.ownertag == '1' ? 'Owner' : player.ownertag == '2' ? 'Co-owner' : player.ownertag == '3' ? 'Captain' : player.ownertag == '4' ? 'Icon' : player.ownertag == '5' ? 'Retain' : ''
      doc.text(tagname, centerX - (tagname.length / 2) * 1.7, centerY + (radius - 2.7)); // Draw each character
      doc.setTextColor('#ffffff')

      centerX += 40
      count += 1

    })


    doc.save(aid + "-" + acname.toUpperCase() + '_TAGLIST.pdf');
  }





  const pdfdownload2 = (playerlist) => {
    //  console.log('psf player list')
    //  console.log(playerlist)
    if (getcatpageData == 0) {
      fetchcatData();
    }
    const doc = new jsPDF('p', 'mm', 'a4');

    doc.addImage(pdfbg, 'JPEG', 0, 0, 210, 297); // Position (x=0, y=0), Size (210mm x 297mm for A4)
    doc.addImage(pdfauctiontitlebg, 'JPEG', 50, 10, 110, 20);
    if (aucteambase64[0]) {
      if (orderby2 !== '3') {

        doc.addImage(aucteambase64[0], 'JPEG', 10, 10, 20, 20);
      }

      if (isspnshow && aucteambase64[1]) {
        doc.addImage(aucteambase64[1], 'JPEG', 175, 10, 20, 20);
      }
      else {
        doc.addImage(aucteambase64[0], 'JPEG', 175, 10, 20, 20);
      }
    }
    else {
      doc.addImage(auctiondefaultLogo, 'JPEG', 10, 10, 20, 20);
      doc.addImage(auctiondefaultLogo, 'JPEG', 175, 10, 20, 20);

    }
    //////////////team wise (Team logo)///////////
    if (orderby2 == 3) {
      if (aucteambase64[playerlist[0].tmid]) {

        doc.addImage(aucteambase64[playerlist[0].tmid], 'JPEG', 10, 10, 20, 20);
      }


    }


    /////////////////Auction name/////////////////////
    doc.setTextColor(255, 255, 255);

    if (acname.length < 27) {
      let alen = acname.length * 3.5
      doc.text(acname.toUpperCase(), 105 - alen / 2, 22);
    }
    else {
      doc.setFontSize(15);

      var fstr = linechanger(acname, 27)
      let alen1 = fstr[0].length * 3.2

      doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 20);
      if (fstr[1].length <= 25) {
        doc.setFontSize(14);

        let alen2 = fstr[1].length * 2.9

        doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 25);
      } else {
        var fsstr = linechanger(fstr[1], 25);
        doc.setFontSize(14);

        let alen2 = fsstr[0].length * 2.9;
        let alen3 = fsstr[1].length * 2.9;
        doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 17);
        doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 24);

      }
    }

    //////////////////////////////////////////////////

    let centerX = 30;
    let centerY = 60;
    let imageSize = 20; // Size of the Image
    let radius = imageSize / 2 + 3; // Radius of the arc
    let adjustCenter = imageSize / 2;

    // Player Printing Maching
    var dumcatid = playerlist[0].catid;
    var dumtid = playerlist[0].tmid;
    let count = 0
    let counter = 0
    playerlist.map((player, index) => {
      if (player.isnonplay == 1) {
        return null;
      }

      if (count == 0) {
        if (orderby2 == 2 && catdata) {
          var catname = catdata?.filter((ct) => ct.cid == player.catid)[0].cname
          let clen = catname.length * 2
          //  console.log('category name')
          doc.text(catname.toUpperCase(), 98 - clen / 2, 50);
          centerY = 70
        }
        if (orderby2 == 3) {

          var teamname = dataTeam.filter((tm) => tm.tid == player.tmid)[0].name;
          let tlen = teamname.length * 2
          doc.text(teamname.toUpperCase(), 95 - tlen / 2, 35);
        }

      }
      if (orderby2 == 2) {
        if (dumcatid !== player.catid) {
          dumcatid = player.catid;
          counter = 0
          count = 0
          doc.addPage();
          doc.setFontSize(16);
          //  console.log('at catdata')
          if (catdata) {
            //  console.log('inside catdata')
            var catname = catdata?.filter((ct) => ct.cid == player.catid)[0].cname;
            //  console.log(catname)
          }
          doc.addImage(pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
          doc.addImage(pdfauctiontitlebg, 'JPEG', 50, 10, 110, 20);

          // doc.addImage(pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
          if (aucteambase64[0]) {
            doc.addImage(aucteambase64[0], 'JPEG', 10, 10, 20, 20);
            if (isspnshow && aucteambase64[1]) {
              doc.addImage(aucteambase64[1], 'JPEG', 175, 10, 20, 20);
            }
            else {
              doc.addImage(aucteambase64[0], 'JPEG', 175, 10, 20, 20);
            }
          }
          else {
            doc.addImage(auctiondefaultLogo, 'JPEG', 10, 10, 20, 20);
            doc.addImage(auctiondefaultLogo, 'JPEG', 175, 10, 20, 20);

          }


          if (acname.length < 27) {

            let alen = acname.length * 4

            doc.text(acname.toUpperCase(), 105 - alen / 2, 20);
          }
          else {
            doc.setFontSize(15);

            var fstr = linechanger(acname, 27)
            let alen1 = fstr[0].length * 3.2

            doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 20);
            if (fstr[1].length <= 25) {
              doc.setFontSize(14);

              let alen2 = fstr[1].length * 2.9

              doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 26);
            } else {
              var fsstr = linechanger(fstr[1], 25);
              doc.setFontSize(14);

              let alen2 = fsstr[0].length * 2.9;
              let alen3 = fsstr[1].length * 2.9;
              doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 26);
              doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 32);

            }
          }
          doc.setFontSize(16);
          let clen = catname.length * 2;
          doc.text(catname.toUpperCase(), 95 - clen / 2, 35);
          centerX = 30
          centerY = 70
          // x = 10;
          // y = 60
        }

      }
      if (orderby2 == 3) {
        // //  console.log("team ki pdfff")

        if (dumtid !== player.tmid) {
          // //  console.log("team change hui")
          dumtid = player.tmid;
          counter = 0
          count = 0
          doc.addPage();
          doc.setFontSize(16);
          var teamname = dataTeam.filter((tm) => tm.tid == player.tmid)[0].name
          // doc.addImage(aucteambase64[player.tmid], 'JPEG', 75, 35, 15, 15);
          doc.addImage(pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
          // doc.addImage(pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
          doc.addImage(pdfauctiontitlebg, 'JPEG', 50, 10, 110, 20);

          if (aucteambase64[0]) {
            if (isspnshow && aucteambase64[1]) {
              doc.addImage(aucteambase64[1], 'JPEG', 175, 10, 20, 20);

            }
            else {

              doc.addImage(aucteambase64[0], 'JPEG', 175, 10, 20, 20);
            }
          }
          else {
            doc.addImage(auctiondefaultLogo, 'JPEG', 175, 10, 20, 20);

          }
          if (aucteambase64[player.tmid]) {
            doc.addImage(aucteambase64[player.tmid], 'JPEG', 10, 10, 20, 20);

          } else {
            doc.addImage(teamdefaultLogo, 'JPEG', 10, 10, 20, 20);

          }

          doc.setFontSize(18);

          if (acname.length < 27) {

            let alen = acname.length * 4

            doc.text(acname.toUpperCase(), 105 - alen / 2, 20);
          }
          else {
            doc.setFontSize(15);

            var fstr = linechanger(acname, 27)
            let alen1 = fstr[0].length * 3.2

            doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 20);
            if (fstr[1].length <= 25) {
              doc.setFontSize(14);

              let alen2 = fstr[1].length * 2.9

              doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 26);
            } else {
              var fsstr = linechanger(fstr[1], 25);
              doc.setFontSize(14);

              let alen2 = fsstr[0].length * 2.9;
              let alen3 = fsstr[1].length * 2.9;
              doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 26);
              doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 32);

            }
          }
          doc.setFontSize(10);

          // doc.text('TEAM PLAYER LIST', 88, 45);
          doc.setFontSize(16);
          let tlen = teamname.length * 2

          doc.text(teamname, 95 - tlen / 2, 35);
          centerX = 30
          centerY = 70
          // doc.addImage(auctiondefaultLogo, 'JPEG', 75, 45, 20, 20);

        }
      }
      // Border circles 
      doc.setDrawColor(165, 148, 247);
      doc.setLineWidth(1);
      doc.circle(centerX, centerY, imageSize / 2 + 0.2, 'S')
      doc.setDrawColor(170, 180, 227);
      doc.setLineWidth(0.3);
      doc.circle(centerX, centerY, imageSize / 2 + 1.8, 'S')
      // Player Image 
      const plingindex = data.list.findIndex((elem) => elem.pid === player.pid)

      doc.addImage(roundbase64Images[plingindex], 'jpeg', centerX - adjustCenter, centerY - adjustCenter, imageSize, imageSize);

      const text = player.pname; // Text to display
      let rta = 0;
      let tlength = text.length / 2;
      const angleOffset = -(Math.PI / 2) * ((tlength + 1) / 14); // Start from top of the circle (-90 degrees)    
      let falselength = 26; ///text.length

      doc.setFontSize(8);
      doc.setTextColor('#ffffff'); // White color or adjust based on background
      doc.setFont("Courier", "normal");

      for (let i = 0; i < text.length; i++) {
        rta = (tlength - 0.5 - i) * 7;
        const char = text[i];
        const angle = angleOffset + (i - (falselength - 1) / 2) * (Math.PI / falselength); // Distribute letters along the arc
        const rotationAngle = angle + Math.PI / 2;
        const x = centerX + radius * Math.cos(angle);
        const y = centerY + radius * Math.sin(angle);
        doc.text(char, x, y, null, rta); // Draw each character
      }
      // doc.setTextColor('#d97c11')
      doc.setFont("Courier", "bold");
      doc.setFontSize(6);
      doc.text(String(index + 1), centerX - (radius + 3), centerY); // Draw each character
      doc.setTextColor('#ffffff')

      ///////////////page change logic/////////////


      centerX += 36





      if ((counter + 1) % 5 == 0) {
        centerY += 30
        centerX = 30
      }
      if ((counter + 1) % 40 == 0) {
        doc.addPage()
        doc.addImage(pdfbg, 'JPEG', 0, 0, 210, 297); // Position (x=0, y=0), Size (210mm x 297mm for A4)

        centerY = 50
        centerX = 30

      }
      count += 1
      counter += 1


    })


    setpdfclk(false)
    if (orderby2 == "" || orderby2 == 1) {

      doc.save(aid + "-" + acname.toUpperCase() + '_PLIST.pdf');
    }
    if (orderby2 == 2) {

      doc.save(aid + "-" + acname.toUpperCase() + '_PLIST_CATEGORY.pdf');
    }
    if (orderby2 == 3) {

      doc.save(aid + "-" + acname.toUpperCase() + '_PLIST_TEAM.pdf');
    }
  }
  const toppdfdownload = () => {
    fetchTeamData()
    if (getcatpageData == 0) {

      fetchcatData();
    }
    function linechanger(str, count) {
      var plsp = str.split(" ")
      let plsplen = 0;
      let whichsp = 0;
      let firststr = "";
      let secstr = "";
      for (let i = 0; i < plsp.length; i++) {
        plsplen += plsp[i].length;

        if (plsplen > count) {

          break;
        }
        whichsp += 1

      }
      var linearr = []
      for (let y = 0; y < whichsp; y++) {
        if (firststr !== '') {
          firststr += " "
        }
        firststr += plsp[y];
      }
      linearr.push(firststr)

      for (let z = whichsp; z < plsp.length; z++) {
        if (secstr !== '') {
          secstr += " "
        }
        secstr += plsp[z];
      }
      linearr.push(secstr)
      return linearr
    }
    const doc = new jsPDF();
    let shouldBreak = false;
    let plcount = 0
    //  console.log('data.list')
    //  console.log(data.list)
    var playersData = data.list
    if (toppltype === '2' && catdata !== "" && catdata !== null) {

      var catwisefull = []

      catdata.forEach((ct) => {
        var catwise = []
        catwise = data.list.filter((dt) => dt.catid == ct.cid)
        if (catwise.length > 0) {
          catwise = [...catwise].sort((a, b) => b.points - a.points);
          catwise = catwise.slice(0, topnum);

          catwise.forEach((ele) => {
            catwisefull.push(ele)
          })
        }
      })
      console.log('catwisefull')
      console.log(catwisefull)
      playersData = catwisefull
    }
    let soldplayers = []
    if (ignoretype == '') {
      soldplayers = playersData.filter((ele) => ele.tmid > 0)
    }
    else if (ignoretype == 'retain') {
      soldplayers = playersData.filter((ele) => ele.tmid > 0 && ele.isfreez !== '1');

    }
    else if (ignoretype == 'cat') {
      soldplayers = playersData.filter((ele) => ele.tmid > 0 && ele.catid !== String(ignorecat));
    }
    else if (ignoretype == 'tag') {
      soldplayers = playersData.filter((ele) => ele.tmid > 0 && ele.ownertag !== ignoretag);
    }
    else if (ignoretype == 'plno') {
      let igids = ignoreplnos.split(',')
      //  console.log(igids)
      soldplayers = playersData.filter((ele) => ele.tmid > 0 && !igids.includes(ele.pcode));

    }
    console.log('soldplayers')
    console.log(soldplayers)
    //  console.log(soldplayers)
    var topplayers = []
    if (toppltype !== '2') {
      const sortedData = [...soldplayers].sort((a, b) => b.points - a.points);
      topplayers = sortedData.slice(0, topnum);

    }
    else {
      topplayers = soldplayers;
    }
    //  console.log('topplayers');
    //  console.log(topplayers);
    if (topplayers.length == 0 || topplayers.length < topnum) {
      alert('Cannot find ' + topnum + ' sold players !!')
      return 0
    }


    if (toptype !== '0' || topnum == 1) {


      topplayers.map((ele, i) => {
        //  console.log('player element')
        //  console.log(ele)
        // if (ele.tmid > 0) {
        //   plcount += 1
        // }
        const plingindex = data.list.findIndex((elem) => elem.pid === ele.pid)
        doc.addImage(base64Images[plingindex], 'JPEG', 65, 95, 82, 82);
        doc.addImage(bgtop1, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
        doc.addImage(toplprofile, 'JPEG', 26, 60, 160, 160);

        if (aucteambase64[0]) {

          doc.addImage(aucteambase64[0], 'JPEG', 10, 20, 40, 40);
          doc.addImage(aucteambase64[0], 'JPEG', 160, 20, 40, 40);
        }
        else {
          doc.addImage(auctiondefaultLogo, 'JPEG', 10, 20, 40, 40);
          doc.addImage(auctiondefaultLogo, 'JPEG', 160, 20, 40, 40);

        }
        doc.addImage(ribbin3, 'PNG', 5, -10, 200, 40);
        doc.setTextColor(34, 46, 94);

        if (acname.length < 27) {
          let alen = acname.length * 3.5
          doc.text(acname.toUpperCase(), 105 - alen / 2, 12);
        }
        else {
          doc.setFontSize(15);

          var fstr = linechanger(acname, 27)
          let alen1 = fstr[0].length * 3.2

          doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 10);
          if (fstr[1].length <= 25) {
            doc.setFontSize(14);

            let alen2 = fstr[1].length * 2.9

            doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 15);
          } else {
            var fsstr = linechanger(fstr[1], 25);
            doc.setFontSize(14);

            let alen2 = fsstr[0].length * 2.9;
            let alen3 = fsstr[1].length * 2.9;
            doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 17);
            doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 24);

          }


        }


        doc.addImage(ribbin, 'PNG', 55, 27, 100, 15);
        doc.addImage(rankbadge, 'PNG', 35, 75, 25, 25);
        doc.setFont('helvetica', 'bold');

        doc.setFontSize(24)
        doc.setTextColor(173, 33, 26);

        doc.text(String((i + 1)), 45, 90);

        // doc.addImage(ribinfo, 'PNG', 45, 200, 100, 20);

        doc.setTextColor(255, 255, 255);
        doc.setFontSize(14);

        doc.text('TOP PLAYERS', 88, 33);
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(20)
        let pnlen = ele.pname.length * 4.5
        doc.setFont('helvetica', 'bold');

        doc.text(ele.pname.toUpperCase(), 105 - pnlen / 2, 183);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(171, 188, 235);
        doc.setFontSize(26)
        doc.text('A U C T I O N', 79, 238);
        doc.setFontSize(16)
        var dateObj = new Date(aucdate);

        // Define months array
        var months = ["January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"];

        // Extract day, month, and year
        var day = dateObj.getDate();
        var monthIndex = dateObj.getMonth();
        var year = dateObj.getFullYear();

        // Format the date
        var formattedDate = day + ' ' + months[monthIndex].slice(0, 3) + ' ' + year;

        doc.text(formattedDate, 91, 247);
        doc.setFont('helvetica', 'bold');
        var tplen = String(parseFloat(ele.points))

        var plen = tplen.length * 4
        //  console.log('plen')
        //  console.log(plen)

        doc.text(String(parseFloat(ele.points)) + ' POINTS', 97 - plen / 2, 203);

        doc.setTextColor(247, 183, 35);
        doc.setFont('helvetica', 'bold');

        //  console.log('ele.tmid')
        //  console.log(ele.tmid)
        //  console.log(dataTeam)

        if (dataTeam.length > 0 && ele.tmid > 0) {
          //  console.log('data team ')
          //  console.log(dataTeam)
          var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
        }
        else {
          var teamname = ''
        }
        var tnlen = teamname.length * 4
        doc.text(String('TEAM : ' + teamname.toUpperCase()), 97 - tnlen / 2, 210);


        if (i == topnum - 1) {
          return true;
        }
        doc.addPage();

      })
    }
    ///////////////////////////single page pdf/////////////////////////
    else {
      //  console.log('single page pdf')


      doc.addImage(pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);

      if (aucteambase64[0]) {
        doc.addImage(aucteambase64[0], 'JPEG', 10, 20, 40, 40);
        doc.addImage(aucteambase64[0], 'JPEG', 160, 20, 40, 40);
      }
      else {
        doc.addImage(auctiondefaultLogo, 'JPEG', 10, 20, 40, 40);
        doc.addImage(auctiondefaultLogo, 'JPEG', 160, 20, 40, 40);

      }
      doc.addImage(ribbin3, 'PNG', 5, -10, 200, 40);
      doc.setTextColor(34, 46, 94);

      if (acname.length < 27) {
        let alen = acname.length * 3.5
        doc.text(acname.toUpperCase(), 105 - alen / 2, 12);
      }
      else {
        doc.setFontSize(15);
        var fstr = linechanger(acname, 27)
        let alen1 = fstr[0].length * 3.2
        doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 10);
        if (fstr[1].length <= 25) {
          doc.setFontSize(14);
          let alen2 = fstr[1].length * 2.9
          doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 15);
        } else {
          var fsstr = linechanger(fstr[1], 25);
          doc.setFontSize(14);
          let alen2 = fsstr[0].length * 2.9;
          let alen3 = fsstr[1].length * 2.9;
          doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 17);
          doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 24);

        }
      }
      doc.addImage(ribbin, 'PNG', 55, 27, 100, 15);
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(14);
      doc.text('TOP PLAYERS', 88, 33);

      if (toppltype == '2') {

        var catname = catdata.filter((ct) => ct.cid == topplayers[0].catid)[0].cname
        let clen = catname.length * 2
        doc.text(catname.toUpperCase(), 100 - clen / 2, 24);
      }
      var imageX = 0;
      var imageY = 0;
      var imagesize = 0
      if (topnum == 2 || topnum == 3) {
        imageX = 78
        imageY = 75
        imagesize = 50
      }
      else if (topnum == 4) {
        imageX = 30
        imageY = 75
        imagesize = 50
      }
      else if (topnum == 5) {
        imageX = 85
        imageY = 65
        imagesize = 40
      }
      else if (topnum == 6) {
        imageX = 30
        imageY = 70
        imagesize = 40
      }
      else if (topnum == 7) {
        imageX = 90
        imageY = 65
        imagesize = 30
      }
      else if (topnum == 8) {
        imageX = 90
        imageY = 55
        imagesize = 25
      }
      else if (topnum == 9) {
        imageX = 30
        imageY = 75
        imagesize = 25
      }
      else if (topnum == 10) {
        imageX = 90
        imageY = 55
        imagesize = 30
      }
      else if (topnum == 11) {
        imageX = 65
        imageY = 65
        imagesize = 25
      }
      else if (topnum == 12) {
        imageX = 30
        imageY = 65
        imagesize = 25
      }
      var plcounter = 0
      var plcounter2 = 0
      console.log('topplayers')
      console.log(topplayers)
      topplayers.map((ele, i) => {
        if (toppltype == '2') {
          i = plcounter
        }
        if (topnum != 10 && topnum != 8) {

          const plingindex = data.list.findIndex((elem) => elem.pid === ele.pid)
          doc.addImage(roundbase64Images[plingindex], 'jpeg', imageX, imageY, imagesize, imagesize);
        }
        if (topnum == 2) {
          doc.addImage(topborderirng, 'jpeg', imageX - 10, imageY - 10, imagesize + 20, imagesize + 20);
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(20);
          doc.setTextColor(255, 255, 255);
          doc.text(String((i + 1)), imageX + imagesize / 2, imageY + imagesize - 1)
          doc.setTextColor(245, 175, 54);

          doc.text(ele.pname, imageX + imagesize / 2 - ele.pname.length * 1.2, imageY + imagesize + 13)
          doc.setFontSize(12);
          doc.setTextColor(255, 255, 255);
          doc.setFont('helvetica', 'normal');
          doc.text(String(parseFloat(ele.points)) + currentauc?.unit+ ' POINTS', imageX + imagesize / 2 - ele.points.length * 1.4, imageY + imagesize + 20)
          if (dataTeam.length > 0 && ele.tmid > 0) {

            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(String('TEAM : ' + teamname.toUpperCase()), imageX + imagesize / 2 - teamname.length * 1.4, imageY + imagesize + 25);
          }
          imageY += 100
        }
        if (topnum == 3) {
          doc.addImage(topborderirng, 'jpeg', imageX - 10, imageY - 10, imagesize + 20, imagesize + 20);
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(20);
          doc.setTextColor(255, 255, 255);
          doc.text(String((i + 1)), imageX + imagesize / 2, imageY + imagesize - 1);
          doc.setTextColor(245, 175, 54);
          doc.text(ele.pname, imageX + imagesize / 2 - ele.pname.length * 2.1, imageY + imagesize + 13);
          doc.setFontSize(12);
          doc.setTextColor(255, 255, 255);
          doc.setFont('helvetica', 'normal');
          doc.text(String(parseFloat(ele.points)) + currentauc?.unit + ' POINTS', imageX + imagesize / 2 - (ele.points.length + 5) * 0.9, imageY + imagesize + 20)
          if (dataTeam.length > 0 && ele.tmid > 0) {

            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(String('TEAM : ' + teamname.toUpperCase()), imageX + imagesize / 2 - (teamname.length + 8), imageY + imagesize + 25);
          }
          if (i == 0) {
            imageY += 90
            imageX -= 50
          }
          else {
            imageX += 100
          }

        }
        if (topnum == 4) {
          doc.addImage(topborderirng, 'jpeg', imageX - 10, imageY - 10, imagesize + 20, imagesize + 20);
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(20);
          doc.setTextColor(255, 255, 255);
          doc.text(String((i + 1)), imageX + imagesize / 2, imageY + imagesize - 1);
          doc.setTextColor(245, 175, 54);
          doc.text(ele.pname, imageX + imagesize / 2 - ele.pname.length * 2.1, imageY + imagesize + 13);
          doc.setFontSize(12);
          doc.setTextColor(255, 255, 255);
          doc.setFont('helvetica', 'normal');
          doc.text(String(parseFloat(ele.points)) + currentauc?.unit + ' POINTS', imageX + imagesize / 2 - (ele.points.length + 5) * 0.9, imageY + imagesize + 20)
          if (dataTeam.length > 0 && ele.tmid > 0) {

            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(String('TEAM : ' + teamname.toUpperCase()), imageX + imagesize / 2 - (teamname.length + 8), imageY + imagesize + 25);
          }
          if (i % 2 == 0 || i == 0) {
            imageX += 100
          }
          else {
            imageX = 30
            imageY += 100
          }

        }
        if (topnum == 5) {
          // if(i==0){
          //   imagesize=45;
          // }
          doc.addImage(topborderirng, 'jpeg', imageX - 8, imageY - 8, imagesize + 16, imagesize + 17);
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(16);
          doc.setTextColor(255, 255, 255);
          doc.text(String((i + 1)), imageX + imagesize / 2 - 0.5, imageY + imagesize);
          doc.setTextColor(245, 175, 54);
          doc.text(ele.pname, imageX + imagesize / 2 - ele.pname.length * 1.7, imageY + imagesize + 13);
          doc.setFontSize(12);
          doc.setTextColor(255, 255, 255);
          doc.setFont('helvetica', 'normal');
          doc.text(String(parseFloat(ele.points)) + currentauc?.unit + ' POINTS', imageX + imagesize / 2 - (ele.points.length + 5) * 0.9, imageY + imagesize + 20)
          if (dataTeam.length > 0 && ele.tmid > 0) {

            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(String('TEAM : ' + teamname.toUpperCase()), imageX + imagesize / 2 - (teamname.length + 8), imageY + imagesize + 25);
          }
          if (i == 0) {
            imageX = 20
            imageY += 55
          }
          else if (i % 2 == 0) {
            imageX = 20
            imageY += 85
          }
          else {
            imageX += 130
          }

        }
        if (topnum == 6) {
          doc.addImage(topborderirng, 'jpeg', imageX - 8, imageY - 8, imagesize + 16, imagesize + 17);
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(16);
          doc.setTextColor(255, 255, 255);
          doc.text(String((i + 1)), imageX + imagesize / 2 - 0.5, imageY + imagesize);
          doc.setTextColor(245, 175, 54);
          doc.text(ele.pname, imageX + imagesize / 2 - ele.pname.length * 1.7, imageY + imagesize + 13);
          doc.setFontSize(12);
          doc.setTextColor(255, 255, 255);
          doc.setFont('helvetica', 'normal');
          doc.text(String(parseFloat(ele.points)) + currentauc?.unit + ' POINTS', imageX + imagesize / 2 - (ele.points.length + 5) * 0.9, imageY + imagesize + 20)
          if (dataTeam.length > 0 && ele.tmid > 0) {

            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(String('TEAM : ' + teamname.toUpperCase()), imageX + imagesize / 2 - (teamname.length + 8), imageY + imagesize + 25);
          }
          if (i % 2 == 0 || i == 0) {
            imageX += 110
          }
          else {
            imageX = 30
            imageY += 75
          }

        }
        if (topnum == 7) {
          doc.addImage(topborderirng, 'jpeg', imageX - 7, imageY - 7, imagesize + 14, imagesize + 15);
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(14);
          doc.setTextColor(255, 255, 255);
          doc.text(String((i + 1)), imageX + imagesize / 2 - 0.5, imageY + imagesize + 1);
          doc.setTextColor(245, 175, 54);
          doc.text(ele.pname, imageX + imagesize / 2 - ele.pname.length * 1.4, imageY + imagesize + 11);
          doc.setFontSize(10);
          doc.setTextColor(255, 255, 255);
          doc.setFont('helvetica', 'normal');
          doc.text(String(parseFloat(ele.points)) + currentauc?.unit + ' POINTS', imageX + imagesize / 2 - (ele.points.length + 5) * 0.9, imageY + imagesize + 17)
          if (dataTeam.length > 0 && ele.tmid > 0) {

            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(String('TEAM : ' + teamname.toUpperCase()), imageX + imagesize / 2 - (teamname.length + 8), imageY + imagesize + 22);
          }
          if (i == 0) {
            imageX = 30
            imageY += 40
          }
          else if (i % 2 == 0) {
            imageX = 30
            imageY += 65
          }
          else {
            imageX += 120
          }

        }
        if (topnum == 8) {
          let rank = i + 1
          if (i == 2) {
            ele = topplayers[i + 1];
            rank = 4
          }
          else if (i == 3) {
            ele = topplayers[i - 1];
            rank = 3
          }
          const plingindex = data.list.findIndex((elem) => elem.pid === ele.pid)
          doc.addImage(roundbase64Images[plingindex], 'jpeg', imageX, imageY, imagesize, imagesize);
          doc.addImage(topborderirng, 'jpeg', imageX - 5, imageY - 5, imagesize + 9, imagesize + 9.5);
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(12);
          doc.setTextColor(255, 255, 255);
          doc.text(String(rank), imageX + imagesize / 2 - 0.5, imageY + imagesize);
          doc.setTextColor(245, 175, 54);
          doc.text(ele.pname, imageX + imagesize / 2 - ele.pname.length * 1.4, imageY + imagesize + 9);
          doc.setFontSize(10);
          doc.setTextColor(255, 255, 255);
          doc.setFont('helvetica', 'normal');
          doc.text(String(parseFloat(ele.points)) + currentauc?.unit + ' POINTS', imageX + imagesize / 2 - (ele.points.length + 5) * 0.9, imageY + imagesize + 15)
          if (dataTeam.length > 0 && ele.tmid > 0) {

            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(String('TEAM : ' + teamname.toUpperCase()), imageX + imagesize / 2 - (teamname.length + 8), imageY + imagesize + 20);
          }
          if (i == 0) {
            // for first
            imageX = 30
            imageY += 35
          }
          else if (i == 1) {
            // after first column
            imageX += 60
            imageY += 18
          }
          else if (i == 2) {
            imageX += 60
            imageY -= 18

          }
          else if (i % 2 !== 0) {
            imageX = 30
            imageY += 65

          }
          else {
            imageX += 120
          }

        }
        if (topnum == 9) {
          doc.addImage(topborderirng, 'jpeg', imageX - 5, imageY - 5, imagesize + 9, imagesize + 9.5);
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(12);
          doc.setTextColor(255, 255, 255);
          doc.text(String((i + 1)), imageX + imagesize / 2 - 1.5, imageY + imagesize - 0.5);
          doc.setTextColor(245, 175, 54);
          doc.text(ele.pname, imageX + imagesize / 2 - ele.pname.length * 1.4, imageY + imagesize + 9);
          doc.setFontSize(8);
          doc.setTextColor(255, 255, 255);
          doc.setFont('helvetica', 'normal');
          doc.text(String(parseFloat(ele.points)) + currentauc?.unit + ' POINTS', imageX + imagesize / 2 - (ele.points.length + 5) * 0.7, imageY + imagesize + 15)
          if (dataTeam.length > 0 && ele.tmid > 0) {

            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(String('TEAM : ' + teamname.toUpperCase()), imageX + imagesize / 2 - (teamname.length + 8) * 0.8, imageY + imagesize + 19);
          }
          if ((i + 1) % 3 == 0) {
            imageX = 30
            imageY += 65
          }
          else {
            imageX += 65

          }

        }
        if (topnum == 10) {
          let rank = i + 1
          if (i == 2) {
            ele = topplayers[i + 1];
            rank = 4
          }
          else if (i == 3) {
            ele = topplayers[i - 1];
            rank = 3
          }
          const plingindex = data.list.findIndex((elem) => elem.pid === ele.pid)
          doc.addImage(roundbase64Images[plingindex], 'jpeg', imageX, imageY, imagesize, imagesize);
          // //  console.log(i)
          // //  console.log(ele)
          doc.addImage(topborderirng, 'jpeg', imageX - 5, imageY - 5, imagesize + 9, imagesize + 10.5);
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(12);
          doc.setTextColor(255, 255, 255);
          doc.text(String(rank), imageX + imagesize / 2 - 1.5, imageY + imagesize - 1.5);
          doc.setTextColor(245, 175, 54);
          doc.text(ele.pname, imageX + imagesize / 2 - ele.pname.length * 1.4, imageY + imagesize + 8);
          doc.setFontSize(8);
          doc.setTextColor(255, 255, 255);
          doc.setFont('helvetica', 'normal');
          doc.text(String(parseFloat(ele.points)) + currentauc?.unit + ' POINTS', imageX + imagesize / 2 - (ele.points.length + 5) * 0.7, imageY + imagesize + 13)
          if (dataTeam.length > 0 && ele.tmid > 0) {

            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(String('TEAM : ' + teamname.toUpperCase()), imageX + imagesize / 2 - (teamname.length + 8) * 0.8, imageY + imagesize + 17);
          }
          if (i == 0) {
            // for first
            imageX = 30
            imageY += 35
          }
          else if (i % 3 == 0) {
            // after last
            imageX = 30
            imageY += 65
          }
          else if ((i + 1) % 3 == 0) {

            // after middle
            imageX += 60
            imageY -= 18
          }
          else if ((i + 2) % 3 == 0) {
            // after first column
            imageX += 60
            imageY += 18
          }


        }
        if (topnum == 11) {
          doc.addImage(topborderirng, 'jpeg', imageX - 5, imageY - 5, imagesize + 9, imagesize + 9.5);
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(12);
          doc.setTextColor(255, 255, 255);
          doc.text(String((i + 1)), imageX + imagesize / 2 - 1.5, imageY + imagesize - 0.5);
          doc.setTextColor(245, 175, 54);
          doc.text(ele.pname, imageX + imagesize / 2 - ele.pname.length * 1.4, imageY + imagesize + 9);
          doc.setFontSize(8);
          doc.setTextColor(255, 255, 255);
          doc.setFont('helvetica', 'normal');
          doc.text(String(parseFloat(ele.points)) + currentauc?.unit + ' POINTS', imageX + imagesize / 2 - (ele.points.length + 5) * 0.7, imageY + imagesize + 15)
          if (dataTeam.length > 0 && ele.tmid > 0) {

            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(String('TEAM : ' + teamname.toUpperCase()), imageX + imagesize / 2 - (teamname.length + 8) * 0.8, imageY + imagesize + 19);
          }
          if (i == 0) {
            imageX += 65
          }
          else if ((i - 1) % 3 == 0) {
            imageX = 30
            imageY += 55
          }
          else {
            imageX += 65

          }

        }
        if (topnum == 12) {
          doc.addImage(topborderirng, 'jpeg', imageX - 5, imageY - 5, imagesize + 9, imagesize + 9.5);
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(12);
          doc.setTextColor(255, 255, 255);
          doc.text(String((i + 1)), imageX + imagesize / 2 - 1.5, imageY + imagesize - 0.5);
          doc.setTextColor(245, 175, 54);
          doc.text(ele.pname, imageX + imagesize / 2 - ele.pname.length * 1.4, imageY + imagesize + 9);
          doc.setFontSize(8);
          doc.setTextColor(255, 255, 255);
          doc.setFont('helvetica', 'normal');
          doc.text(String(parseFloat(ele.points)) + currentauc?.unit + ' POINTS', imageX + imagesize / 2 - (ele.points.length + 5) * 0.7, imageY + imagesize + 15)
          if (dataTeam.length > 0 && ele.tmid > 0) {

            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(String('TEAM : ' + teamname.toUpperCase()), imageX + imagesize / 2 - (teamname.length + 8) * 0.8, imageY + imagesize + 19);
          }
          if ((i + 1) % 3 == 0) {
            imageX = 30
            imageY += 55
          }
          else {
            imageX += 65

          }

        }
        plcounter += 1
        plcounter2 += 1
        if (toppltype == '2') {
          if ((i + 1) % topnum == 0 && topplayers.length > plcounter2) {
            console.log(i)
            doc.addPage()
            plcounter = 0
            doc.addImage(pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);

            if (aucteambase64[0]) {
              doc.addImage(aucteambase64[0], 'JPEG', 10, 20, 40, 40);
              doc.addImage(aucteambase64[0], 'JPEG', 160, 20, 40, 40);
            }
            else {
              doc.addImage(auctiondefaultLogo, 'JPEG', 10, 20, 40, 40);
              doc.addImage(auctiondefaultLogo, 'JPEG', 160, 20, 40, 40);

            }
            doc.addImage(ribbin3, 'PNG', 5, -10, 200, 40);
            doc.setTextColor(34, 46, 94);

            if (acname.length < 27) {
              let alen = acname.length * 3.5
              doc.text(acname.toUpperCase(), 105 - alen / 2, 12);
            }
            else {
              doc.setFontSize(15);
              var fstr = linechanger(acname, 27)
              let alen1 = fstr[0].length * 3.2
              doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 10);
              if (fstr[1].length <= 25) {
                doc.setFontSize(14);
                let alen2 = fstr[1].length * 2.9
                doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 15);
              } else {
                var fsstr = linechanger(fstr[1], 25);
                doc.setFontSize(14);
                let alen2 = fsstr[0].length * 2.9;
                let alen3 = fsstr[1].length * 2.9;
                doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 17);
                doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 24);

              }
            }
            doc.addImage(ribbin, 'PNG', 55, 27, 100, 15);
            doc.setTextColor(255, 255, 255);
            doc.setFontSize(14);
            doc.text('TOP PLAYERS', 88, 33);

            if (toppltype == '2') {
              // //  console.log(topplayers[i])
              // var  t = i +1
              // //  console.log(topplayers[i + 1])
              // //  console.log(topplayers[t])

              var catname = catdata.filter((ct) => ct.cid == topplayers[plcounter2]?.catid)[0]?.cname
              //  console.log('cat info......')
              //  console.log(topplayers[i + 1])
              //  console.log(catdata)
              //  console.log(catname)
              let clen = catname?.length * 2
              if (catname) {

                doc.text(catname?.toUpperCase(), 100 - clen / 2, 24);
              }
            }


            if (topnum == 2 || topnum == 3) {
              imageX = 78
              imageY = 75
              imagesize = 50
            }
            else if (topnum == 4) {
              imageX = 30
              imageY = 75
              imagesize = 50
            }
            else if (topnum == 5) {
              imageX = 85
              imageY = 65
              imagesize = 40
            }
            else if (topnum == 6) {
              imageX = 30
              imageY = 70
              imagesize = 40
            }
            else if (topnum == 7) {
              imageX = 90
              imageY = 65
              imagesize = 30
            }
            else if (topnum == 8) {
              imageX = 90
              imageY = 55
              imagesize = 25
            }
            else if (topnum == 9) {
              imageX = 30
              imageY = 75
              imagesize = 25
            }
            else if (topnum == 10) {
              imageX = 90
              imageY = 55
              imagesize = 30
            }
            else if (topnum == 11) {
              imageX = 65
              imageY = 65
              imagesize = 25
            }
            else if (topnum == 12) {
              imageX = 30
              imageY = 65
              imagesize = 25
            }
          }
        }

      })

    }
    doc.save(aid + "-" + acname.toUpperCase() + '_TOP-PLIST.pdf');
  }
  // var sizeX=200;
  // var sizeY=220;
  // var ratio=0.5;
  const handleCheckboxChange = (index) => {
    const selectedIndex = selectedpllist.indexOf(index);
    if (selectedIndex === -1) {
      setselectedpllist([...selectedpllist, index]);
    } else {
      const updatedSelection = [...selectedpllist];
      updatedSelection.splice(selectedIndex, 1);
      setselectedpllist(updatedSelection);
    }
    // //  console.log(selectedcats)
  };
  const plwisepdf = () => {
    var doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: [200, 220]
    });
    var soldcount = 0;
    data.list.map((ele, i) => {
      doc.addImage(plbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
      if (aucteambase64[0]) {
        doc.addImage(aucteambase64[0], 'JPEG', 10, 10, 40, 40);
        doc.addImage(aucteambase64[0], 'JPEG', 150, 10, 40, 40);
        // //  console.log("jjjjjjjjjjjjjjjjjjjjjj2222222222222222")

      }
      else {
        doc.addImage(auctiondefaultLogo, 'JPEG', 10, 10, 40, 40);
        doc.addImage(auctiondefaultLogo, 'JPEG', 150, 10, 40, 40);

      }
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(18);

      // doc.setDrawColor(72, 104, 153);
      // doc.rect(9.5, 9.5, 41, 41);

      // doc.setDrawColor(72, 104, 153);
      // doc.rect(149.5, 9.5, 41, 41);
      doc.setTextColor(255, 255, 255);

      doc.setFillColor(171, 212, 208); // RGB values for blue
      doc.roundedRect(60, 65, 75, 75, 2, 2, 'F'); // 'F' stands for 'fill'
      doc.rect(15, 159, 125, 15, 'F'); // 'F' stands for 'fill'

      doc.setTextColor(31, 29, 122); // Set text color to red
      let plen = ele.pname.length * 4
      doc.text(ele.pname.toUpperCase(), (62.5 - plen / 2) + 15, 169);
      doc.setTextColor(255, 255, 255);

      doc.setFillColor(18, 62, 138); // RGB values for blue
      doc.rect(15, 174, 125, 15, 'F'); // 'F' stands for 'fill'

      doc.rect(140, 149, 43, 43, 'F');
      // doc.roundedRect(140, 149, 43, 43, 5, 5);
      doc.clip();
      if (parseInt(ele.tmid) > 0) {
        if (aucteambase64[ele.tmid]) {

          doc.addImage(aucteambase64[ele.tmid], 'JPEG', 141, 150, 41, 41);
        }
        else {
          doc.addImage(teamdefaultLogo, 'JPEG', 141, 150, 41, 41);
        }
      }
      if (base64Images[i]) {
        doc.addImage(base64Images[i], 'JPEG', 61, 66, 73, 73);
      }
      else {
        doc.addImage(playerdefaultLogo, 'PNG', 61, 66, 73, 73);
      }
      // doc.addImage(playerdefaultLogo, 'JPEG', 141, 150, 41, 41);


      doc.setFontSize(14);
      doc.setFont('helvetica', 'normal');

      doc.text('WILL PLAY FOR ', 65, 182);
      doc.setFontSize(18);
      doc.setFont('helvetica', 'bold');


      doc.setFillColor(18, 62, 138); // RGB values for blue
      doc.rect(1, 204, 198, 15, 'F'); // 'F' stands for 'fill'

      doc.setFontSize(18);
      let alen = acname.length * 4
      doc.setFont('helvetica', 'bold');

      doc.text(acname.toUpperCase(), 100 - alen / 2, 213);

      doc.addPage();
      if (ele.tmid > 0) {
        soldcount += 1
      }


    })
    if (soldcount > 0) {

      doc.save(aid + "-" + acname.toUpperCase() + '_TOP-PLIST.pdf');
    }
    else {
      alert("No player sold till now !!")
    }
  }

  const generatePDF = () => {
    const element = document.getElementById('content-to-pdf');
    const opt = {
      margin: 0.5,
      filename: 'example.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    html2pdf().from(element).set(opt).save();
  };
  return (
    <>
      <LoadingOverlay
        active={isActive}
        spinner={<BounceLoader color={"#337ab7"} />}
      >
        {/* <button onClick={generatePDF}>Generate PDF</button>
            <div id="content-to-pdf">
                <h1>Hello, this is HTML content with an image</h1>
                <img src={aucteambase64[0]} style={{ maxWidth: '100%', height: 'auto' }} alt="Example Image" />
            </div> */}
        {pdfclk &&
          <>

            <div className="pdfpopup">
              {/* <FontAwesomeIcon className="pdfclose" onClick={pdfcls} icon={faXmark} /> */}
              <div>
                <div className="pdoptline1">
                  <div className="pdopt1">
                    <select class="form-select" value={orderby2} onChange={(e) => { setorderby2(e.target.value) }} aria-label="Default select example">
                      <option selected hidden default disabled value="">Page Record</option>
                      <option value="1">ALL</option>
                      <option value="2">Category wise</option>
                      <option value="3">Team wise</option>
                      <option value="4">Top Players</option>
                      <option value="5">Player wise</option>
                      <option value="6">Owners</option>

                    </select>
                  </div>

                  {orderby2 == '4' &&
                    <div className="popt3">
                      <select class="form-select" value={toppltype} onChange={(e) => { settoppltype(e.target.value) }} aria-label="Default select example">
                        <option selected default hidden disabled value="">TOP TYPE?</option>
                        <option value="1">All</option>
                        <option value="2">Category wise</option>
                      </select>
                    </div>
                  }
                  {orderby2 == '4' &&
                    <div className="popt3">
                      <select class="form-select" value={topnum} onChange={(e) => { settopnum(e.target.value) }} aria-label="Default select example">
                        <option selected default hidden disabled value="">TOP ?</option>
                        <option value="1">Top 1</option>
                        <option value="2">Top 2</option>
                        <option value="3">Top 3</option>
                        <option value="4">Top 4</option>
                        <option value="5">Top 5</option>
                        <option value="6">Top 6</option>
                        <option value="7">Top 7</option>
                        <option value="8">Top 8</option>
                        <option value="9">Top 9</option>
                        <option value="10">Top 10</option>
                        <option value="11">Top 11</option>
                        <option value="12">Top 12</option>
                      </select>
                    </div>
                  }
                  {orderby2 == '4' &&
                    <div className="popt3">
                      <select class="form-select" value={toptype} onChange={(e) => { settoptype(e.target.value) }} aria-label="Default select example">
                        <option selected default hidden disabled value="">TOP Type</option>
                        <option value="0">On single page</option>
                        <option value="1">Multiple</option>

                      </select>
                    </div>
                  }


                  {orderby2 !== "4" && orderby2 !== "6" && <>
                    <div className="pdopt2">

                      <select class="form-select" value={orderby} onChange={(e) => { setorderby(e.target.value) }} aria-label="Default select example">
                        <option selected hidden default disabled value="">Order By</option>
                        {
                          orderby2 == 1 && <>
                            <option value="1">Player Number</option>
                            <option value="2">PLayer Name</option>
                            <option value="3">Category</option>
                            <option value="4">Category-Namewise</option>
                          </>
                        }
                        {
                          orderby2 == 2 && <>
                            <option value="1">Player Number</option>
                            <option value="2">PLayer Name</option>
                          </>
                        }
                        {
                          orderby2 == 3 && <>
                            <option value="5">Sold sequence</option>
                            <option value="6">Category</option>
                            <option value="7">Value</option>
                            <option value="8">PLayer Name</option>
                          </>
                        }

                      </select>
                    </div>
                    {orderby2 !== "4" &&
                      <div className="popt3">
                        <select class="form-select" value={pdflayouttype} onChange={(e) => { setpdflayouttype(e.target.value) }} aria-label="Default select example">
                          <option selected default hidden disabled value="">Layout Type</option>
                          <option value="0">Type 1</option>
                          <option value="1">Type 2</option>
                        </select>

                      </div>

                    }

                    {pdflayouttype == '0' && <div className="popt3">
                      <select class="form-select" value={colno} onChange={(e) => { setcolno(e.target.value) }} aria-label="Default select example">
                        <option selected default hidden disabled value="">column</option>
                        <option value="2">Three</option>
                        <option value="1">Two</option>
                      </select>
                    </div>}
                    <div className="popt4">

                      {
                        colno == 1 &&
                        <select class="form-select" value={numofpl} onChange={(e) => { setnumofpl(e.target.value) }} aria-label="Default select example">
                          <option selected default hidden disabled value="">Perpage Players</option>
                          <option value={12}>First page-12/Rest-14</option>
                          <option value={14}>First page-14/Rest-16</option>
                          <option value={16}>First page-16/Rest-18</option>
                        </select>
                      }
                      {
                        colno == 2 &&
                        <select class="form-select" value={numofpl} onChange={(e) => { setnumofpl(e.target.value) }} aria-label="Default select example">
                          <option selected default hidden disabled value="">Perpage Players</option>
                          <option value={24}>First page-24/Rest-30</option>
                          <option value={27}>First page-27/Rest-33</option>
                          <option value={30}>First page-30/Rest-36</option>
                          <option value={33}>First page-33/Rest-39</option>
                        </select>
                      }
                    </div> </>
                  }

                </div>
                {
                  orderby2 == '4' && <>
                    <div className="pdoptline2">
                      <div className="pdopt5">
                        <select class="form-select" value={ignoretype} onChange={(e) => { setignoretype(e.target.value) }} aria-label="Default select example">
                          <option selected hidden default disabled value="">Want to ignore?</option>
                          <option value="retain">Retain</option>
                          <option value="cat">Category</option>
                          <option value="tag">Tag</option>
                          <option value="plno">Player Number</option>
                        </select>
                      </div>
                      {ignoretype == 'cat' && <div className="pdopt5">
                        <select class="form-select" value={ignorecat} onChange={(e) => { setignorecat(e.target.value) }} aria-label="Default select example">
                          <option selected default value="">select category</option>
                          {catdata && catdata?.map((cat) => {
                            return (
                              <option value={cat.cid}>{cat.cname}</option>
                            )
                          }

                          )}


                        </select>
                      </div>}
                      {ignoretype == 'tag' && <div className="pdopt5">
                        <select class="form-select" value={ignoretag} onChange={(e) => { setignoretag(e.target.value) }} aria-label="Default select example">
                          <option selected hidden default disabled value="">select Tag</option>
                          <option value='0' selected>
                            Select tag
                          </option>
                          <option value='1'>
                            Owner
                          </option>
                          <option value='2' >
                            Co-owner
                          </option>
                          <option value='3'>
                            Captain
                          </option>
                          <option value='4'>
                            Icon
                          </option>
                          <option value='5'>
                            Retain
                          </option>
                        </select>
                      </div>}
                    </div>
                    {ignoretype == 'plno' && <div className="pdopt5">
                      <div>Comma separated player number. Ex: 25,50,30</div>

                      <input type="text" placeholder="Enter Player numbers" value={ignoreplnos} onChange={(e) => setignoreplnos(e.target.value)} />
                    </div>}
                  </>
                }
                {orderby2 != '4' && orderby2 != '6' && <>
                  <div className="pdoptline2">
                    <div className="pdopt5">
                      <select class="form-select" value={sts} onChange={(e) => { setsts(e.target.value) }} aria-label="Default select example">
                        <option selected hidden default disabled value="">status</option>
                        <option value="1">ALL</option>
                        <option value="2">Available</option>
                        <option value="3">Sold</option>
                        <option value="4">Unsold</option>
                        <option value="5">Unsold + available</option>
                        <option value="6">Available + unsold</option>
                      </select>
                    </div>

                    {/* <div> */}
                    {pdflayouttype != '1' && <div className="setdataopt">
                      <button className="setdata" onClick={setdata}>Manage more data</button>

                    </div>}

                  </div>
                  <div className="pdoptline2">
                    {issetdata &&
                      <>
                        <div className="showopt">
                          <div className="showoptline">
                            <div class="form-check">
                              <input class="check1" type="checkbox" onChange={(e) => setisplnoshow(e.target.checked)} checked={isplnoshow} id="flexCheckDefault1" />
                              <label class="form-check-label checklabel" for="flexCheckDefault1">
                                Show player Number
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="check1" type="checkbox" onChange={(e) => setispointsshow(e.target.checked)} checked={ispointsshow} id="flexCheckDefault2" />
                              <label class="form-check-label checklabel" for="flexCheckDefault2">
                                Show points
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="check1" type="checkbox" onChange={(e) => setiscatshow(e.target.checked)} checked={iscatshow} id="flexCheckDefault5" />
                              <label class="form-check-label checklabel" for="flexCheckDefault5">
                                Show category
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="check1" type="checkbox" onChange={(e) => setisspnshow(e.target.checked)} checked={isspnshow} id="flexCheckDefault56" />
                              <label class="form-check-label checklabel" for="flexCheckDefault6">
                                Show Sponsor
                              </label>
                            </div>
                          </div>
                          <div className="showoptline">
                            <div class="form-check">
                              <input class="check1" type="checkbox" onChange={(e) => setismobnoshow(e.target.checked)} checked={ismobnoshow} id="flexCheckDefault3" />
                              <label class="form-check-label checklabel" for="flexCheckDefault3">
                                Show mobile Number
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="check1" type="checkbox" onChange={(e) => setistshirtshow(e.target.checked)} checked={istshirtshow} id="flexCheckDefault4" />
                              <label class="form-check-label checklabel" for="flexCheckDefault4">
                                Show Tshirt size
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="check1" type="checkbox" onChange={(e) => setisbasePriceShow(e.target.checked)} checked={isbasePriceShow} id="flexCheckDefault11" />
                              <label class="form-check-label checklabel" for="flexCheckDefault11">
                                Show Base price
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="check1" type="checkbox" onChange={(e) => setisvalshow(e.target.checked)} checked={isvalshow} id="flexCheckDefault10" />
                              <label class="form-check-label checklabel" for="flexCheckDefault10">
                                Show value
                              </label>
                            </div>

                          </div>
                          <div className="showoptline">
                            <div class="form-check">
                              <input class="check1" type="checkbox" onChange={(e) => setisspec1(e.target.checked)} checked={isspec1} id="flexCheckDefault7" />
                              <label class="form-check-label checklabel" for="flexCheckDefault7">
                                Show spec_1
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="check1" type="checkbox" onChange={(e) => setisspec2(e.target.checked)} checked={isspec2} id="flexCheckDefault8" />
                              <label class="form-check-label checklabel" for="flexCheckDefault8">
                                Show spec_2
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="check1" type="checkbox" onChange={(e) => setisspec3(e.target.checked)} checked={isspec3} id="flexCheckDefault9" />
                              <label class="form-check-label checklabel" for="flexCheckDefault9">
                                Show spec_3
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="check1" type="checkbox" onChange={(e) => setisownershow(e.target.checked)} checked={isownershow} id="flexCheckDefault13" />
                              <label class="form-check-label checklabel" for="flexCheckDefault13">
                                Show owner
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="check1" type="checkbox" onChange={(e) => setisdetailshow(e.target.checked)} checked={isdetailshow} id="flexCheckDefault13" />
                              <label class="form-check-label checklabel" for="flexCheckDefault13">
                                Show detail
                              </label>
                            </div>

                          </div>
                        </div>

                      </>
                    }


                  </div>
                </>
                }
                {
                  orderby2 == '6' &&
                  <>
                    <div className="tagoptioncontainer">
                      <div >

                        <input type="checkbox" id="ownertag" checked={isownertagselect} onChange={(e) => setisownertagselect(e.target.checked)} />
                        <label htmlFor="ownertag">Owner</label>
                      </div>
                      <div >

                        <input type="checkbox" id="co-owner" checked={iscoownertagselect} onChange={(e) => setiscoownertagselect(e.target.checked)} />
                        <label htmlFor="co-owner">Co-Owner</label>
                      </div>
                      <div >

                        <input type="checkbox" id="captain" checked={iscaptaintagselect} onChange={(e) => setiscaptaintagselect(e.target.checked)} />
                        <label htmlFor="captain">Captain</label>
                      </div>
                      <div >

                        <input type="checkbox" id="icon" checked={isicontagselect} onChange={(e) => setisicontagselect(e.target.checked)} />
                        <label htmlFor="icon">Icon</label>
                      </div>
                      <div >

                        <input type="checkbox" id="retain" checked={isretaintagselect} onChange={(e) => setisretaintagselect(e.target.checked)} />
                        <label htmlFor="retain">Reatin</label>
                      </div>
                    </div>
                  </>
                }

                <button className='btn btn-primary pdclose' onClick={pdfcls} >Close</button>
                <button className='btn btn-primary pddwn' onClick={() => { orderby2 == '6' ? tagwisedownload() : orderby2 == '4' ? toppdfdownload() : orderby2 == '5' ? plwisepdf() : pdfdownload() }}>Download PDF</button>
              </div>
              {pdflayouttype !== '' && orderby2 !== '4' && orderby2 !== '5' && <div className="layoutdemodiv">
                LAYOUT
                <div>
                  <img src={pdflayouttype == '0' ? pdflayout1 : pdflayout2} className="pdflayoutimg" alt="" />
                </div>


              </div>}
            </div>
          </>}
        {isexcelclk &&
          <>
            <div className="pdfdiv"></div>
            <div className="pdfpopup excelpopup">
              <div className="pdoptline1">
                <div className="pdopt1">
                  <select class="form-select" value={exceltype} onChange={(e) => { setexceltype(e.target.value) }} aria-label="Default select example">
                    <option selected hidden default disabled value="">Excel Type</option>
                    <option value="1">Normal Excel</option>
                    <option value="2">For unsold</option>
                    <option value="3">Final Excel</option>
                    {/* <option value="3">Team wise</option> */}

                  </select>
                </div>

                {/* <div className="popt3">
                  <select class="form-select" value={colno} onChange={(e) => { setcolno(e.target.value) }} aria-label="Default select example">
                    <option selected default hidden disabled value="">column</option>
                    <option value="1">Two</option>
                    <option value="2">Three</option>
                  </select>
                </div>
                <div className="popt4">

                  {
                    colno == 1 &&
                    <select class="form-select" value={numofpl} onChange={(e) => { setnumofpl(e.target.value) }} aria-label="Default select example">
                      <option selected default hidden disabled value="">Perpage Players</option>
                      <option value={12}>First page-12/Rest-14</option>
                      <option value={14}>First page-14/Rest-16</option>
                      <option value={16}>First page-16/Rest-18</option>
                    </select>
                  }
                  {
                    colno == 2 &&
                    <select class="form-select" value={numofpl} onChange={(e) => { setnumofpl(e.target.value) }} aria-label="Default select example">
                      <option selected default hidden disabled value="">Perpage Players</option>
                      <option value={24}>First page-24/Rest-30</option>
                      <option value={27}>First page-27/Rest-33</option>
                      <option value={30}>First page-30/Rest-36</option>
                      <option value={33}>First page-33/Rest-39</option>
                    </select>
                  }
                </div> */}
                <div className="setdataopt">
                  <button className="setdata" onClick={() => setisexcelmore(!isexcelmore)}>Manage more data</button>
                </div>
              </div>
              {isexcelmore &&
                <>
                  <div className="showopt">
                    <div className="showoptline">
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelplno(e.target.checked)} checked={isexcelplno} id="flexCheckDefault1" />
                        <label class="form-check-label checklabel" for="flexCheckDefault1">
                          Show player Number
                        </label>
                      </div>

                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelcat(e.target.checked)} checked={isexcelcat} id="flexCheckDefault5" />
                        <label class="form-check-label checklabel" for="flexCheckDefault5">
                          Show category
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelage(e.target.checked)} checked={isexcelage} id="flexCheckDefault5" />
                        <label class="form-check-label checklabel" for="flexCheckDefault5">
                          Show age
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexceldob(e.target.checked)} checked={isexceldob} id="flexCheckDefault5" />
                        <label class="form-check-label checklabel" for="flexCheckDefault5">
                          Show Dob
                        </label>
                      </div>

                      {exceltype == 3 && <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelteam(e.target.checked)} checked={isexcelteam} id="flexCheckDefault2" />
                        <label class="form-check-label checklabel" for="flexCheckDefault2">
                          Show Teams
                        </label>
                      </div>}
                    </div>
                    <div className="showoptline">
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelmob(e.target.checked)} checked={isexcelmob} id="flexCheckDefault3" />
                        <label class="form-check-label checklabel" for="flexCheckDefault3">
                          Show mobile Number
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelfname(e.target.checked)} checked={isexcelfname} id="flexCheckDefault4" />
                        <label class="form-check-label checklabel" for="flexCheckDefault4">
                          Show Fname
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisisexceldetail(e.target.checked)} checked={isexceldetail} id="flexCheckDefault4" />
                        <label class="form-check-label checklabel" for="flexCheckDefault4">
                          Show Detail
                        </label>
                      </div>
                      {exceltype == 3 && <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelpoints(e.target.checked)} checked={isexcelpoints} id="flexCheckDefault2" />
                        <label class="form-check-label checklabel" for="flexCheckDefault2">
                          Show points
                        </label>
                      </div>}


                      {/* {exceltype==3 && <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setisvalshow(e.target.checked)} checked={isvalshow} id="flexCheckDefault10" />
                          <label class="form-check-label checklabel" for="flexCheckDefault10">
                            Show value
                          </label>
                        </div>} */}

                    </div>
                    <div className="showoptline">
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexceltshirt(e.target.checked)} checked={isexceltshirt} id="flexCheckDefault4" />
                        <label class="form-check-label checklabel" for="flexCheckDefault4">
                          Show Tshirt size
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexceltrouser(e.target.checked)} checked={isexceltrouser} id="flexCheckDefault4" />
                        <label class="form-check-label checklabel" for="flexCheckDefault4">
                          Show Trouser size
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexceljname(e.target.checked)} checked={isexceljname} id="flexCheckDefault4" />
                        <label class="form-check-label checklabel" for="flexCheckDefault4">
                          Show Jersey Name
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexceljno(e.target.checked)} checked={isexceljno} id="flexCheckDefault4" />
                        <label class="form-check-label checklabel" for="flexCheckDefault4">
                          Show Jersey Number
                        </label>
                      </div>

                    </div>

                    <div className="showoptline">
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelsp1(e.target.checked)} checked={isexcelsp1} id="flexCheckDefault7" />
                        <label class="form-check-label checklabel" for="flexCheckDefault7">
                          Show spec_1
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelsp2(e.target.checked)} checked={isexcelsp2} id="flexCheckDefault8" />
                        <label class="form-check-label checklabel" for="flexCheckDefault8">
                          Show spec_2
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelsp3(e.target.checked)} checked={isexcelsp3} id="flexCheckDefault9" />
                        <label class="form-check-label checklabel" for="flexCheckDefault9">
                          Show spec_3
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelimage(e.target.checked)} checked={isexcelimage} id="flexCheckDefault15" />
                        <label class="form-check-label checklabel" for="flexCheckDefault15">
                          Show Image Link
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelbasebid(e.target.checked)} checked={isexcelbasebid} id="flexCheckDefault9" />
                        <label class="form-check-label checklabel" for="flexCheckDefault9">
                          Show BaseBid
                        </label>
                      </div>

                    </div>
                  </div>
                </>
              }

              {/* <div className="pdoptline2">
                <div className="pdopt5">
                  <select class="form-select" value={sts} onChange={(e) => { setsts(e.target.value) }} aria-label="Default select example">
                    <option selected hidden default disabled value="">status</option>
                    <option value="1">ALL</option>
                    <option value="2">Available</option>
                    <option value="3">Sold</option>
                  </select>
                </div>

                <div className="setdataopt">
                  <button className="setdata" onClick={setdata}>Manage more data</button>

                </div>
              </div>
              <div className="pdoptline2">
                {issetdata &&
                  <>
                    <div className="showopt">
                      <div className="showoptline">
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setisplnoshow(e.target.checked)} checked={isplnoshow} id="flexCheckDefault1" />
                          <label class="form-check-label checklabel" for="flexCheckDefault1">
                            Show player Number
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setispointsshow(e.target.checked)} checked={ispointsshow} id="flexCheckDefault2" />
                          <label class="form-check-label checklabel" for="flexCheckDefault2">
                            Show points
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setiscatshow(e.target.checked)} checked={iscatshow} id="flexCheckDefault5" />
                          <label class="form-check-label checklabel" for="flexCheckDefault5">
                            Show category
                          </label>
                        </div>
                      </div>
                      <div className="showoptline">
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setismobnoshow(e.target.checked)} checked={ismobnoshow} id="flexCheckDefault3" />
                          <label class="form-check-label checklabel" for="flexCheckDefault3">
                            Show mobile Number
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setistshirtshow(e.target.checked)} checked={istshirtshow} id="flexCheckDefault4" />
                          <label class="form-check-label checklabel" for="flexCheckDefault4">
                            Show Tshirt size
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setisvalshow(e.target.checked)} checked={isvalshow} id="flexCheckDefault10" />
                          <label class="form-check-label checklabel" for="flexCheckDefault10">
                            Show value
                          </label>
                        </div>

                      </div>
                      <div className="showoptline">
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setisspec1(e.target.checked)} checked={isspec1} id="flexCheckDefault7" />
                          <label class="form-check-label checklabel" for="flexCheckDefault7">
                            Show spec_1
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setisspec2(e.target.checked)} checked={isspec2} id="flexCheckDefault8" />
                          <label class="form-check-label checklabel" for="flexCheckDefault8">
                            Show spec_2
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setisspec3(e.target.checked)} checked={isspec3} id="flexCheckDefault9" />
                          <label class="form-check-label checklabel" for="flexCheckDefault9">
                            Show spec_3
                          </label>
                        </div>

                      </div>
                    </div>
                  </>
                }
              </div> */
              }


              <button className='btn btn-primary pdclose' onClick={excelcls} >Close</button>
              <button className='btn btn-primary pddwn' onClick={exceldownload} >Download Excel</button>
            </div>
          </>}
        <div>
          <Navigationtitle data={match} />
          {/* {  <div>
            player 1 
            <img src={base64Images[0]} alt="kkmk" />
          </div>} */}
          {/* <button></button> */}
          {pdfDataUri && (
            <iframe
              title="Player Cards PDF"
              src={pdfDataUri}
              width="100%"
              height="500"
              style={{ border: 'none' }}
            />
          )}
          {/* <Document>
            <Page size="A4">
              <View style={styles.imageContainer}>
                <ClipPath id="myClipPath">
                  {createClippingPath(200, 200, radius)}
                </ClipPath>
                <Image style={styles.image} src={auclogopath + auclogo + '?c'} clipPath="url(#myClipPath)" />
              </View>
            </Page>
          </Document> */}

          {/* <div  className={`bulkdelenable ${isbulkdelenable && 'bulkenable'}`} onClick={()=>setisbulkdelenable(prev=>!prev)}><TiUserDelete /></div> */}
          {/* <button className="btn btn-primary getfinalexcel " onClick={excelclk}>Excel</button> */}
          {/* <Link to={'/players-pdf'}> <button className="btn btn-primary base64 " >base64</button></Link> */}
          {/* <button onClick={() => base64()} className="btn btn-primary base64 " >base64</button> */}
          {/* {//  console.log("ffffffffffffffffffffffffffffff")}
          {//  console.log(auclogopath + auclogo)} */}
          <img
            ref={(img) => {
              aucteamrefs.current['0'] = img
              handleaucimgload(0)
            }}
            style={{ display: 'none' }}
            onLoad={handleaucimgload(0)}
            fallback={
              <Shimmer
                width={"100%"}
                height={"auto"}
              />
            }
            src={auclogopath + auclogo + '?c'}
            alt="base img" crossOrigin="Anonymous" />
          <img
            ref={(img) => {
              aucteamrefs.current['1'] = img
              handleaucimgload(1)
            }}
            style={{ display: 'none' }}
            onLoad={handleaucimgload(1)}
            fallback={
              <Shimmer
                width={"100%"}
                height={"auto"}
              />
            }
            src={sponsorlogo}
            alt="base img" crossOrigin="Anonymous" />
          <img
            ref={(img) => {
              pldefault.current['0'] = img
              // handlepldefaultload(0)
            }}
            style={{ display: 'none' }}
            // onLoad={handlepldefaultload(0)}
            fallback={
              <Shimmer
                width={"100%"}
                height={"auto"}
              />
            }
            src={playerdefaultLogo}
            alt="base img" crossOrigin="Anonymous" />

          {dataTeam != "" && dataTeam.map((ele) => {
            // //  console.log("team se related")
            // //  console.log(ele)
            return (<img style={{ display: 'none' }} src={teampath + ele.logo + '?c'}
              ref={(img) => { aucteamrefs.current[ele.tid] = img; handleaucimgload(ele.tid) }}
              onLoad={handleaucimgload(ele.tid)}
              alt="base img" crossOrigin="Anonymous" />)
          })}
          <div id="top-categories" className="top-cat-area  bottom-less">

            <div className="container-fluid padding-left-0px">
              <section
                id="advisor"
                className="advisor-area default-padding bottom-less"
              >
                <div className="container-fluid ">




                  {/* <img src="https://mscspa.s3.amazonaws.com/playersphoto/230510124585589.jpg" ref={yourImageRef} alt="" /> */}

                  {/* <img src={base64Images[6]} alt="pl image" /> */}

                  <div className="row">
                    <div className="plheader">
                      <div className="plfilters" onKeyDown={onKeyDownHandler}>
                        <input
                          className="form-control"
                          placeholder="Pl.No / Name / Mob.No"
                          type="text"
                          name="searchText"
                          value={filter.searchText}
                          onChange={handleFilterChange}

                        />
                        <select class="form-select" name="selectedStatus"
                          value={filter.selectedStatus}
                          onChange={handleFilterChange} aria-label="Default select example">
                          <option selected default disabled hidden value="">Status</option>

                          <option value="1">ALL</option>
                          <option value="2">Available</option>
                          <option value="3">Sold</option>
                          <option value="4">Freezed</option>
                          <option value="5">Unold</option>
                          <option value="6">Owners</option>

                        </select>
                        <select class="form-select" name="selectedCategory"
                          value={filter.selectedCategory}
                          onChange={handleFilterChange} aria-label="Default select example">
                          <option selected default value="1">Category(ALL)</option>

                          {catdata !== "" && catdata?.map(
                            (ct) => (
                              <option
                                value={ct.cid}
                                key={ct.cid}
                              >
                                {ct.cname}
                              </option>
                            )
                          )}

                        </select>
                        <select class="form-select" value={filorder} onChange={(e) => { setorderdata(e.target.value) }} aria-label="Default select example">
                          <option selected default disabled hidden value="">Order By</option>

                          <option value="1">Player Number</option>
                          <option value="2">PLayer Name</option>

                        </select>
                      </div>

                      <div className="plbuttons">
                        <div> <button className="btn btn-primary pl-btn " onClick={gotoimport}>Import Players</button>                        </div>
                        <div>
                          <button className="btn btn-primary  pl-btn" onClick={getpdf}>PDF</button>
                        </div>
                        <div>
                          <button className="btn btn-primary pl-btn" onClick={excelclk}>Excel</button>

                        </div>
                      </div>
                    </div>
                    {/* {pldata?.map((ele) => {
                      return (<div className="testingpdf" ref={reportTemplateRef}>
                        <div className="testingpdf2">

                          <img src={playerdefaultLogo} alt="" />
                        </div>
                        <div className="parent" >
                          <p > This is player...</p>
                          <></>


                        </div>
                      </div>)
                    })} */}
                    <div>
                      {/* <button onClick={() => handleGeneratePdf()}>Generate PDF</button> */}
                    </div>


                    <div className="advisor-items text-center text-light pl-container">
                      <h4 className="plcount"> {data?.list?.length} PLAYERS</h4>
                      {data != "" ? (
                        data.list?.map((dt, index) => {
                          // var fgstyle = {
                          //   color: 'none'

                          // }

                          // if (dt.tmid > 0) {

                          //   fgstyle = {
                          //     color: 'red'
                          //   }
                          //   var mytitle = "Sold"
                          // }
                          // else if (dt.isskiped !== "0") {
                          //   fgstyle = {
                          //     color: 'yellow'
                          //   }
                          // }
                          // else if (dt.isnonplay !== "0") {
                          //   fgstyle = {
                          //     color: 'blue'
                          //   }
                          //   var mytitle = "Non Playing"
                          // }
                          var pcolor = 'jj'
                          var pbgcolor = 'plimgh'
                          var pnumcolor = 'plnumber'
                          var soldptsboxclass = 'soldptsbox'
                          if ((dt.isskiped && dt.isskiped !== "0") || dt.tmid > 0 || dt.isnonplay !== "0") {
                            var pcolor = 'plred';
                            pbgcolor = 'plimgh2'
                            pnumcolor = 'plnumber2'
                            soldptsboxclass = 'soldptsbox2'
                          }
                          else if (dt.isskiped == 1) {
                            // var pcolor = "plfreeze";
                          }
                          if (dt.isfreez == 1) {
                            var pcolor = "plred plfreeze";

                          }
                          if (dt.tmid == "0" || dt.tmid == "") {
                            var pcolor = "cnormal";
                            pbgcolor = 'plimgh'
                          }


                          var morefields = null
                          if (dt.runwkt != "" && dt.runwkt != null) {
                            var morefields = JSON.parse(dt.runwkt)
                          }
                          // //  console.log('cat data bta')
                          // //  console.log(catdata)
                          if (catdata !== '') {

                            var catname = catdata?.filter((ct) => ct.cid == dt.catid)[0]?.cname
                            // //  console.log(catname)
                          }
                          // console.log(dt)
                          //  console.log('tmids') 
                          //  console.log(parseInt(dt.tmid)) 

                          return (
                            <div onMouseEnter={() => setHoveredCard(index)} onMouseLeave={() => setHoveredCard(null)} className="col-md-4 col-sm-6 col-xs-6 single-item padding-10 player-single">

                              <div style={{ overflow: 'visible' }} className="advisor-item">
                                <div style={{ overflow: 'visible' }} className="info-box plbox">
                                  {/* {
                                    (dt.isskiped !== "0" || dt.tmid > 0 || dt.isnonplay !== "0") &&
                                    <FontAwesomeIcon className="fgicon" title={mytitle} style={fgstyle} icon={faFlag} />

                                  } */}


                                  <div className="row mar-right-0">

                                    <div className="col-md-4 col-sm-6   padding-r-0 ">
                                      <div className={pbgcolor}>
                                        <div className={pnumcolor}>{dt.pcode}</div>

                                        {/* <canvas
                                          ref={(ref) => {
                                            if (ref) {
                                              const canvas = ref;
                                              const ctx = canvas.getContext('2d');
                                              const img = new Image();
                                              img.src = 'https://mscspa.s3.amazonaws.com/playersphoto/230510124585589.jpg'; 
                                              img.onload = () => ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                                              canvasRefs.current.push(canvas);
                                            }
                                          }}
                                          width={100}
                                          height={100}
                                          style={{ display: 'flex' }}
                                        /> */}
                                        <img

                                          ref={(img) => {

                                            imageRefs.current[index] = img
                                            handleImageLoad(index)
                                          }}
                                          onLoad={handleImageLoad(index)}
                                          fallback={
                                            <Shimmer
                                              width={"100%"}
                                              height={"auto"}
                                            />
                                          }
                                          src={
                                            (dt.img == null || dt.img == "")
                                              ? playerdefaultLogo
                                              : data.path + dt.img + '?c'
                                          }
                                          crossOrigin="Anonymous"
                                        />
                                        {parseInt(dt.tmid) > 0 && <div className={soldptsboxclass}>{parseInt(dt.points).toFixed(currentauc.isdecm)}</div>}
                                        {/* {//  console.log(data.path + dt.img)} */}
                                      </div>

                                      <div className="card-icon player-edit pleditbtns">
                                        {/* <div ><span className="plnumcontainer">22</span></div> */}
                                        <Link
                                          className="edit-icon"
                                          to={
                                            "/edit-auction-player/" +
                                            encode(dt.pid)
                                          }
                                        >
                                          <AiIcons.AiFillEdit></AiIcons.AiFillEdit>
                                        </Link>

                                        <Link
                                          className="delete-icon"
                                          to={"#"}
                                          onClick={() => deldata(dt.pid)}
                                        >
                                          <AiIcons.AiFillDelete></AiIcons.AiFillDelete>
                                        </Link>
                                      </div>
                                    </div>

                                    <div className="col-sm-6 width-full padding-l-0">
                                      <div className={`info-title player-info p-name ${pcolor}`}>
                                        {dt.pname}
                                        {dt.isowner > 0 &&
                                          <FontAwesomeIcon icon={faCrown} className="f-crown-icon" />
                                        }
                                      </div>

                                      <div className="info-title player-info">
                                        <div className="row plin">
                                          {
                                            /* <div className="col-md-6 col-xs-12 plcode">
  
                                              {" "}
                                              P.NO.{" "}
                                              {" "}
                                              :<b className="player-info-b">{dt.pcode} </b>
                                            </div> */
                                          }

                                          {/* {(dt.age !== "0" && dt.age !== "") && <div className="col-md-6 col-xs-12 ">
                                            Age{" "}
                                            : <b className="player-info-b">{dt.age
                                              //getAge(dt.dob)
                                            }</b>
                                          </div>} */}
                                        </div>

                                        <div className="row spcs">
                                          {(dt.age !== "0" && dt.age !== "") && <div className="info-title player-info col-md-12 ">
                                            Age{" "}
                                            : <b className="player-info-b">{dt.age
                                              //getAge(dt.dob)
                                            }</b>
                                          </div>}
                                          {dt.spcf1 && <div className="info-title player-info col-md-12 ">
                                            {dt.spcf1}
                                          </div>}

                                          {dt.spcf2 && <div className="info-title player-info col-md-12">
                                            {dt.spcf2}
                                          </div>}
                                          {dt.spcf3 && <div className="info-title player-info col-md-12">
                                            {dt.spcf3}
                                          </div>}
                                          {catname && <div className="info-title player-info col-md-12">
                                            From {catname.toUpperCase()}
                                          </div>}
                                          {/* {morefields !==null && morefields.map((item,ind)=>{
                                            return (
                                              <div className="info-title player-info col-md-12">
                                              {item['N']} :{item['V']}
                                            </div>
                                            )
                                          })} */}
                                          {morefields !== null && Object.entries(morefields).map(([key, value]) => {
                                            if (value.V !== "") {
                                              return (
                                                <div className="info-title player-info col-md-12">
                                                  {value.N}:{value.V}
                                                </div>
                                              )
                                            }

                                          })}
                                          <div className="info-title player-info col-md-12">

                                          </div>
                                          {(parseInt(dt.tmid) > 0 && dataTeam != "") &&
                                            <div className="info-title player-info col-md-12 ">

                                              <span className="fz-1"> Sold to</span><span className="soldteam">   {dataTeam && dataTeam.filter((ele) => ele.tid == dt.tmid)[0]?.name}</span>
                                            </div>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                    {/* <div className="delinpselect">  {(hoveredCard == index || selectedpllist.includes(dt.pid)) && <>   <input type="checkbox" className='catcheck' checked={selectedpllist.includes(dt.pid)} onChange={() => handleCheckboxChange(dt.pid)} />
                                    </>} 
                                     </div> */}
                                    {/* <div className={badg}>Sold</div> */}
                                    {/* {
                                      dt.isfreez == 1 && <div className="badge2"></div>
                                    } */}

                                  </div>


                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : <button onClick={() => { history.push('add-auction-player') }} className="customaddbtn">Add Player</button>}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </LoadingOverlay>
    </>
  );
}

export default Players;
